import { EventEmitter, Output } from '@angular/core';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationService } from 'primeng/api';
import { AppComponent } from 'src/app/app.component';
import { LegalizacionService } from 'src/app/services/legalizacion.service';

@Component({
  selector: 'app-modify-datatable',
  templateUrl: './modify-datatable.component.html',
  styleUrls: ['./modify-datatable.component.scss']
})
export class ModifyDatatableComponent implements OnInit {

  obrasSelect: any = "''2-4'',''2-8'',''104-164'',''104-165'',''104-166'',''104-167'',''104-168'',''104-169'',''107-100'',''107-101'',''107-102'',''107-103'',''107-104'',''107-106'',''107-107'',''107-108'',''107-109'',''107-110'',''107-111'',''107-116'',''107-117'',''107-118'',''107-119'',''107-121'',''107-122'',''107-123'',''107-124'',''107-125'',''107-126'',''107-127'',''107-128'',''107-129'',''107-130'',''107-133'',''107-134'',''107-135'',''107-136'',''107-137'',''107-138'',''107-139'',''107-140'',''107-141'',''107-142'',''107-143'',''107-144'',''107-145'',''108-105'',''108-106'',''111-146'',''111-147'',''112-1107'',''112-1108'',''112-1109'',''112-1110'',''112-1111'',''112-1112'',''112-1113'',''112-113'',''112-114'',''122-12'',''122-13'',''123-101'',''123-102'',''124-101'',''124-102'',''128-10'',''129-100'',''129-101'',''130-4'',''130-5'',''131-100'',''131-101'',''132-100'',''132-101'',''133-107'',''133-109'',''133-111'',''133-115'',''133-116'',''138-1'',''138-2'',''139-1'',''139-10'',''139-11'',''139-2'',''139-3'',''139-8'',''140-100'',''146-100'',''147-100'',''147-101'',''149-100'',''149-101'',''149-102'',''152-1'',''152-10'',''152-11'',''152-2'',''152-3'',''152-4'',''152-7'',''152-8'',''152-9'',''153-1'',''153-10'',''153-11'',''153-12'',''153-2'',''153-3'',''153-4'',''153-5'',''153-6'',''153-7'',''153-8'',''153-9'',''154-1'',''154-2'',''155-1'',''155-2'',''156-1'',''156-2'',''156-3'',''157-1'',''157-2'',''158-3'',''158-4'',''159-1'',''160-1'',''160-138'',''160-139'',''160-140'',''160-141'',''160-142'',''160-143'',''160-144'',''160-145'',''160-146'',''160-147'',''161-100'',''161-101'',''162-100'',''162-101'',''162-102'',''162-104'',''162-105'',''162-106'',''162-107'',''163-100'',''2-102'',''2-113'',''2-117'',''2-15'',''2-16'',''2-18'',''2-22'',''2-23'',''2-24'',''2-26'',''2-266'',''2-290'',''2-294'',''2-30'',''2-301'',''2-31'',''2-32'',''2-328'',''2-333'',''2-337'',''2-338'',''2-346'',''2-35'',''2-369'',''2-371'',''2-373'',''2-376'',''2-38'',''2-380'',''2-383'',''2-384'',''2-399'',''2-400'',''2-406'',''2-417'',''2-422'',''2-423'',''2-424'',''2-425'',''2-426'',''2-427'',''2-428'',''2-429'',''2-430'',''2-431'',''2-435'',''2-447'',''2-449'',''2-452'',''2-455'',''2-457'',''2-458'',''2-462'',''2-464'',''2-465'',''2-466'',''2-467'',''2-468'',''2-469'',''2-470'',''2-471'',''2-472'',''2-473'',''2-476'',''2-477'',''2-497'',''2-498'',''2-509'',''2-510'',''2-513'',''2-518'',''2-519'',''2-520'',''2-526'',''2-527'',''2-537'',''2-538'',''2-541'',''2-550'',''2-563'',''2-564'',''2-565'',''2-578'',''2-580'',''2-586'',''2-644'',''2-645'',''2-646'',''2-652'',''2-658'',''2-661'',''2-663'',''2-665'',''2-667'',''2-668'',''2-669'',''2-670'',''2-671'',''2-672'',''2-681'',''2-693'',''2-694'',''2-695'',''2-696'',''2-715'',''2-73'',''2-739'',''2-740'',''2-741'',''2-742'',''2-753'',''2-776'',''2-78'',''2-79'',''2-793'',''2-799'',''2-800'',''2-813'',''2-814'',''2-839'',''2-840'',''2-875'',''27-342'',''55-1'',''74-1'',''74-2'',''74-3'',''77-509'',''77-510'',''77-513'',''77-514'',''77-516'',''77-518'',''80-447'',''87-101'',''87-102'',''87-103'',''93-101'',''93-102'',''93-103'',''93-104'',''93-105'',''93-108'',''96-10'',''96-11'',''96-2'',''96-21'',''96-22'',''96-25'',''96-26'',''96-3'',''96-33'',''96-34'',''96-35'',''96-36'',''96-37'',''96-4'',''96-5'',''96-6'',''96-7'',''96-8'',''96-9''";

  public estadoCoordinadorList: any = [];
  public estadoAnalistaList: any = [];
  public asignacionAnalistaList: any = [];
  public horaEntregaList: any = [];
  public tipificacionCorreccionesCtlList: any = [];
  public creacionCasoList: any = [];
  public estadoAnalistaVaradoList: any = [];
  public analistaVaradoList: any = [];
  public tipoInconsistenciaList: any = [];
  public comunicadosEnviadosList: any = [];


  public frplList: any = [];
  public quienFirmaEsfpList: any = [];
  public estadoEsfpFrplList: any = [];
  public estadoAbogadoList: any = [];
  public presentoCambioList: any = [];
  public estadoPySList: any = [];
  public estadoEscrituradoList: any = [];
  public tipificacionMesAnteriorList: any = [];
  public operacionList: any = [];
  public analistaACargoNotariaList: any = [];

  public campanasEspecialesList: any = [];
  public notificacionesNegocioList: any = [];
  public causalRenovacionList: any = [];
  public estadoPoderAnalistaList: any = [];
  public tipoDeNovedadList: any = [];
  public analistaOutsourcingList: any = [];
  public caidaEntregasList: any = [];
  public analistaEntregasList: any = [];
  public tubosDeGestionList: any = [];
  public estadoPromesasList: any = [];
  public recorridoJuridicoList: any = [];
  public clienteExteriorList: any = [];

  public prioridadDelNegocioList: any = [];
  public responsableQueReportaList: any = [];
  public notificacionesCartaList: any = [];
  public fuenteList: any = [];
  public analistaNegociosEnRiesgoList: any = [];
  public documentoFirmadoList: any = [];
  public estadoDelEncargoList: any = [];
  public tipoDeClausulaSiAplicaParaEncargoList: any = [];
  public causalFamiliaList: any = [];
  public subsanadoAl100List: any = [];
  public soportesList: any = [];
  public nuevaSolicitudEnOtroBancoList: any = [];
  public causalManejoDeAuxiliarList: any = [];
  public causalDeRiesgoList: any = [];
  public causalDeRiesgos2List: any = [];
  public causalDeRiesgos3List: any = [];
  public causalDeRiesgos4List: any = [];
  public estrategiaDesistimientoList: any = [];
  public negocioMetaAnioActualList: any = [];


  public analistaAsignadoList: any = [];
  public clasificacionSisbenList: any = [];
  public tuboGestionList: any = [];
  public simmularConMCYList: any = [];
  public estadoSubsidioMCYList: any = [];
  public observacionCampanaEnrolamientoSisbenList: any = [];
  public negocioConCierreFinancieroList: any = [];
  public bonoEstrategiaCreditoList: any = [];
  public clienteNoAceptaList: any = [];
  public agendaList: any = [];
  public semaforoSatisfaccionList: any = [];


  public formaDevolucionList: any = [];
  public entidadEncargadaDevolucionList: any = [];
  public estadoDesistimientoList: any = [];
  public tipoDesistimientoList: any = [];
  public estadoFinalList: any = [];
  public negocioFenalpagareList: any = [];
  public casosAutorizacionEspecialList: any = [];
  public ajusteAplicacionPagoList: any = [];
  public tipoSolicitudList: any = [];
  public procesoPendienteCarteraList: any = [];
  public responsableCarteraList: any = [];
  public observacionCarteraList: any = [];
  public aplicacionBonoDescuentoList: any = [];
  public causalDevolucionList: any = [];
  public observacionesAnalistaTramitesList: any = [];
  public documentoGeneradoList: any = [];
  public responsableCarteraDosList: any = [];

  public estadoRecaudoList : any = [];
  public estadoCreditoList : any = [];
  public estadoPromesaList : any = [];
  public estadoLegalizacionList : any = [];
  public estadoEscrituracionList : any = [];
  public estadoEntregaList : any = [];
  public estadoPoderesList : any = [];
  public motivoRiesgoList : any = [];




  LEGALIZACION: number = 1;
  PROMESA: number = 2;
  SUBSIDIO: number = 3;
  SEGUIMIENTO_SUBSIDIO: number = 4;
  ENTREGA: number = 5;
  DESEMBOLSO: number = 6;
  RECAUDO: number = 7;
  TRAZABILIDAD: number = 8;
  ORDENES: number = 9;
  RENOVACION: number = 10;
  ESCRITURACION: number = 11;
  RIESGO: number = 12;
  RENEGOCIACION: number = 13;
  DESISTIMIENTOS: number = 14;
  PAZYSALVOS: number = 15;
  MACRO360: number = 16;
  INTERNACIONAL: number = 17;


  form: FormGroup;
  beforeList: [] = [];

  public currentElement: any = {};
  private obras: any;
  private sortStr: any;
  private filterStr: any;

  searchTextEstadoCoordinador: any;
  searchTextEstadoAnalista: any;
  searchTextAsignacionAnalista: any;
  searchTextHoradeEntrega: any;
  searchTextTipificacionCorreccionesCtl: any;
  searchTextcreacionCaso: any;
  searchTextTipoInconsistencia: any;
  searchTextComunicadosEnviados: any;

  searchTextFrp: any;
  searchTextQuienFirmaEsfp: any;
  searchTextEstadoEsfpFrpl: any;
  searchTextEstadoAbogado: any;
  searchTextPresentoCambio: any;
  searchTextestadoPyS: any;

  searchTextCampanasEspeciales: any;
  searchTextNotificacionesNegocio: any;
  searchTextCausalRenovacion: any;
  searchTextEstadoPoderAnalista: any;
  searchTextTipoDeNovedad: any;
  searchTextAnalista_Outsourcing: any;
  searchTextEstadoEscriturado: any;
  searchTextTipificacionMesAnterior: any;
  searchTextOperacion: any;
  searchTextTipoProyectoM: any;

  searchTextCaidaEntregas: any;
  searchTextAnalistaEntregas: any;
  searchTextTubosDeGestion: any;
  searchTextEstadoPromesas: any;
  searchRecorridoJuridico: any;
  searchClienteExterior: any;

  searchTextAnalistaACargoNotaria: any;

  searchTextEstadoAnalistaVarado: any;
  searchTextAnalistaVarado: any;

  searchPrioridadDelNegocio: any;
  searchResponsableQueReporta: any;
  searchNotificacionesCarta: any;
  searchFuente: any;
  searchAnalistaNegociosEnRiesgo: any;
  searchDocumentoFirmado: any;
  searchEstadoDelEncargo: any;
  searchTipoDeClausulaSiAplicaParaEncargo: any;
  searchCausalFamilia: any;
  searchSubsanadoAl100: any;
  searchSoportes: any;
  searchNuevaSolicitudEnOtroBanco: any;
  searchCausalManejoDeAuxiliar: any;
  searchCausalDeRiesgo: any;
  searchCausalDeRiesgos2: any;
  searchCausalDeRiesgos3: any;
  searchCausalDeRiesgos4: any;
  searchEstrategiaDesistimiento: any;
  searchNegocioMetaAnioActual: any;

  searchAnalistaAsignado: any;
  searchClasificacionSisben: any;
  searchSimmularConMCY: any;

  searchTextEstadoRecaudo: any;
  searchTextEstadoCredito: any;
  searchTextEstadoPromesa: any;
  searchTextEstadoLegalizacion: any;
  searchTextEstadoEscrituracion: any;
  searchTextEstadoEntrega: any;
  searchTextEstadoPoderes: any;
  searchTextMotivoRiesgo: any;


  EstadoSubsidioMCY: any;
  ValorCreditoAcordado: any;
  ObservacionCampanaEnrolamientoSisben: any;
  NegocioConCierreFinanciero: any;
  BonoEstrategiaCredito: any;
  ClienteNoAcepta: any;
  Agenda: any;
  SemaforoSatisfaccion: any;

  Indemnizacion: any;
  FormaDevolucion: any;
  EntidadEncargadaDevolucion: any;
  EstadoDesistimiento: any;
  TipoDesistimiento: any;
  EstadoFinal: any;
  NegocioFenalpagare: any;
  CasosAutorizacionEspecial: any;
  AjusteAplicacionPago: any;
  TipoSolicitud: any;
  ProcesoPendienteCartera: any;
  ResponsableCartera: any;
  ObservacionCartera: any;
  AplicacionBonoDescuento: any;
  CausalDevolucion: any;
  ObservacionesAnalistaTramites: any;
  DocumentoGenerado: any;
  ResponsableCarteraDos: any;
  ValorBonoDescuento: any;

  displayLoading: boolean = false;

  reportType: number;
  numRegistros: number = 0;

  disableValidation = {
    FechadeEntrega: true,
    HoradeEntrega: true,
    CreacionCaso: true,
    Apoderado: true,
    EstadoCoordinador: true,
    ObservacionCoordinador: true,
    EstadoAnalista: true,
    ObservacionAnalista: true,
    Arquitecta: true,

    FechaSeguimientoCoordinador: true,
    FechaSeguimientoAnalista: true,
    FechaAsignacion: true,
    AsignacionAnalista: true,
    AnalistaVarado: true,
    EstadoAnalistaVarado: true,

    Bloqueante: true,

    Comentarios: true,

    TipificacionCorreccionesCtl: true,
    AnalistaTrazabilidad: true,

    TipoInconsistencia: true,
    ComunicadosEnviados: true,

    AuxOrdenesEscrituracion: true,
    Frpl: true,
    QuienFirmaEsfp: true,
    EstadoEsfpFrpl: true,
    EstadoAbogado: true,
    ObservacionAbogado: true,
    PresentoCambio: true,
    CualFueElCambio: true,
    NoPredialNacional: true,
    NumeroId: true,
    IdMunicipio: true,
    RadicacionOrdenPagoPySPredial: true,
    FechaEstimadaDePyS: true,
    TipoPyS: true,
    MunicipioPyS: true,
    EstadoPyS: true,
    EstadoOrdenes: true,
    ObservacionAnalistaACargo: true,
    AnalistaACargoNotaria: true,

    TipoDeNovedad: true,
    Analista_Outsourcing: true,

    CampanasEspeciales: true,
    FechaSeguimientoBanco: true,
    EstadoBanco: true,
    ObservacionBanco: true,
    FechaUltimaNotificacion: true,
    FechaCompromiso: true,
    NotificacionesNegocio: true,
    CausalRenovacion: true,
    EstadoPoderAnalista: true,
    AsignacionAnalistaPromesas: true,

    FechaAcuerdoProximoPago: true,
    MontoPactado: true,
    LlamadaNo1: true,
    LlamadaNo2: true,
    Fenalco1erBarrido: true,
    Fenalco2doBarrido: true,
    LlamadaNo3: true,
    LlamadaNo4: true,
    LlamadaNo5: true,
    EstadoEscriturado: true,
    TipificacionMesAnterior: true,
    FechaEnvioSMS: true,
    FechaNotificacionAlerta: true,
    FechaCarta1: true,
    FechaCarta2: true,
    FechaCarta3: true,
    AnalistaRecaudo: true,
    Operacion: true,
    LlamadaNo_1: true,
    LlamadaNo_2: true,
    LlamadaNo_3: true,


    CaidaEntregas: true,
    AnalistaEntregas: true,
    TubosDeGestion: true,
    EstadoPromesas: true,
    FechaPredial: true,
    FechaEstampilla: true,
    FechaPoderFidubogota: true,
    RecorridoJuridico: true,
    ClienteExterior: true,
    FechaAsigna: true,
    FechaMetaComite: true,
    FechaMetaCelula: true,
    AnalistaEscrituracion: true,


    ID_PA: true,
    FechaSubsanado: true,
    FechaSeguimientoAnalista2: true,
    FechaInicialSeguimientoAnalista: true,
    PrioridadDelNegocio: true,
    MesDeGestion: true,
    ResponsableQueReporta: true,
    NotificacionesCarta: true,
    Fuente: true,
    AnalistaNegociosEnRiesgo: true,
    FechaCompromisoAnalista: true,
    DocumentoFirmado: true,
    EstadoDelEncargo: true,
    TipoDeClausulaSiAplicaParaEncargo: true,
    CausalFamilia: true,
    SubsanadoAl100: true,
    Soportes: true,
    ObservacionesDeNegociosEnRiesgo: true,
    BancoDeCreditoNegado: true,
    NuevaSolicitudEnOtroBanco: true,
    NombreDelBanco: true,
    ValorDeSancion: true,
    EstadoParaDesistir: true,
    AsesorDelBanco: true,
    CausalManejoDeAuxiliar: true,
    TiempoRespuesta: true,
    CreditoAprobado: true,
    CausalDeRiesgo: true,
    CausalDeRiesgos2: true,
    CausalDeRiesgos3: true,
    CausalDeRiesgos4: true,
    EstrategiaDesistimiento: true,
    NegocioMetaAnioActual: true,

    FechaEstadoCoordinador: true,
    FechaEstadoAnalista: true,

    FechaGestion: true,
    TuboGestion: true,
    AnalistaAsignado: true,
    Compromiso: true,
    FechaProxGestion: true,
    NegocioConCierreFinanciero: true,
    RecursosPropios: true,
    IngresoFamiliar: true,
    ClasificacionSisben: true,
    SimmularConMCY: true,
    AccionRecomendada: true,
    EstadoSubsidioMCY: true,
    ValorCreditoAcordado: true,
    ObservacionCampanaEnrolamientoSisben: true,
    AvanceObra: true,
    BonoEstrategiaCredito: true,
    ClienteNoAcepta: true,
    FechaInicioEstado: true,
    FechaAgenda: true,
    Agenda: true,
    SemaforoSatisfaccion: true,
    NumeroRadicadoEnrolamiento: true,
    FechaEnrolamiento: true,
    PostuladoMCY: true,

    Indemnizacion: true,
    FormaDevolucion: true,
    Banco: true,
    NumeroCuenta: true,
    TipoCuenta: true,
    EntidadEncargadaDevolucion: true,
    EstadoDesistimiento: true,
    TipoDesistimiento: true,
    FechaEnvioCertificacionBancaria: true,
    FechaElaboracionMemorando: true,
    NumeroMemorando: true,
    EstadoFinal: true,
    Observaciones: true,
    NotaMemoFidudavivienda: true,
    Asistente: true,
    VoboAnalista: true,
    NegocioFenalpagare: true,
    CasosAutorizacionEspecial: true,
    AjusteAplicacionPago: true,
    TipoSolicitud: true,
    ProcesoPendienteCartera: true,
    ResponsableCartera: true,
    ObservacionCartera: true,
    AplicacionBonoDescuento: true,
    CausalDevolucion: true,
    ObservacionesAnalistaTramites: true,
    DocumentoGenerado: true,
    ResponsableCarteraDos: true,
    ValorBonoDescuento: true,
    LiquidadorGastosEscrituracion: true,
    MotivoDevolucion: true,
    FechaSolicitud: true,
    FechaRevision: true,
    FechaObservacionAjustes: true,
    FechaEvacuadoPyS: true,
    FechaNotificacionObsTramites: true,
    FechaDevolucionTramites: true,

    AsesorSeguimiento1: true,
    AsesorSeguimiento2: true,
    NotificacionCarta: true,
    ObservacionAsesor: true,
    EstadoRecaudo: true,
    EstadoCredito: true,
    EstadoPromesa: true,
    EstadoLegalizacion: true,
    EstadoEscrituracion: true,
    EstadoEntrega: true,
    EstadoPoderes: true,
    MotivoRiesgo: true,


  }

  constructor(
    private legalizacionService: LegalizacionService,
    public dialogRef: MatDialogRef<ModifyDatatableComponent>,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    console.log('##### data', data.element);
    this.currentElement = data.element;
    this.reportType = data.reportType;
    this.numRegistros = data.numRegistros;
    console.log('num registros ', this.numRegistros);
    console.log('num registros ', this.numRegistros);


    this.sortStr = data.sortFilter;
    this.filterStr = data.filter;
    this.obras = data.obras;


    let toolName = this.getToolName(this.reportType);

    AppComponent.displayLoading = true;
    this.legalizacionService.getOptionListModal(toolName, 'EstadoCoordinador')
      .subscribe(
        (response: any) => {
          console.log(response);
          this.estadoCoordinadorList = response;
          AppComponent.displayLoading = false;

          let existe : boolean = false;
          for (let index = 0; index < response.length; index++) {
            const element = response[index];
            if(element == this.form.controls['EstadoCoordinador'].value){
              existe = true;
            }
          }

          if(this.form.controls['EstadoCoordinador'].value != null && this.form.controls['EstadoCoordinador'].value != '' && !existe){
            this.estadoCoordinadorList.unshift(this.form.controls['EstadoCoordinador'].value);
          }

          this.estadoCoordinadorList.unshift('Vacio');
        }
      )

    AppComponent.displayLoading = true;
    this.legalizacionService.getOptionListModal(toolName, 'EstadoAnalista')
      .subscribe(
        (response: any) => {
          console.log(response);
          this.estadoAnalistaList = response;
          AppComponent.displayLoading = false;

          let existe : boolean = false;
          for (let index = 0; index < response.length; index++) {
            const element = response[index];
            if(element == this.form.controls['EstadoAnalista'].value){
              existe = true;
            }
          }

          if(this.form.controls['EstadoAnalista'].value != null && this.form.controls['EstadoAnalista'].value != '' && !existe){
            this.estadoAnalistaList.unshift(this.form.controls['EstadoAnalista'].value);
          }

          this.estadoAnalistaList.unshift('Vacio');
        }
      )

    if (this.reportType == 1) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AsignacionAnalista')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.asignacionAnalistaList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['AsignacionAnalista'].value){
                existe = true;
              }
            }

            if(this.form.controls['AsignacionAnalista'].value != null && this.form.controls['AsignacionAnalista'].value != '' && !existe){
              this.asignacionAnalistaList.unshift(this.form.controls['AsignacionAnalista'].value);
            }

            this.asignacionAnalistaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 1) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoAnalistaVarado')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoAnalistaVaradoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoAnalistaVarado'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoAnalistaVarado'].value != null && this.form.controls['EstadoAnalistaVarado'].value != '' && !existe){
              this.estadoAnalistaVaradoList.unshift(this.form.controls['EstadoAnalistaVarado'].value);
            }


            this.estadoAnalistaVaradoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 1) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AnalistaVarado')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.analistaVaradoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['AnalistaVarado'].value){
                existe = true;
              }
            }

            if(this.form.controls['AnalistaVarado'].value != null && this.form.controls['AnalistaVarado'].value != '' && !existe){
              this.analistaVaradoList.unshift(this.form.controls['AnalistaVarado'].value);
            }

            this.analistaVaradoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 3) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TipoInconsistencia')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tipoInconsistenciaList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['TipoInconsistencia'].value) {
                existe = true;
              }
            }

            if (this.form.controls['TipoInconsistencia'].value != null && this.form.controls['TipoInconsistencia'].value != '' && !existe) {
              this.tipoInconsistenciaList.unshift(this.form.controls['TipoInconsistencia'].value);
            }

            this.tipoInconsistenciaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 3) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ComunicadosEnviados')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.comunicadosEnviadosList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ComunicadosEnviados'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ComunicadosEnviados'].value != null && this.form.controls['ComunicadosEnviados'].value != '' && !existe) {
              this.comunicadosEnviadosList.unshift(this.form.controls['ComunicadosEnviados'].value);
            }

            this.comunicadosEnviadosList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 3) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoSubsidioMCY')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoSubsidioMCYList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['EstadoSubsidioMCY'].value) {
                existe = true;
              }
            }

            if (this.form.controls['EstadoSubsidioMCY'].value != null && this.form.controls['EstadoSubsidioMCY'].value != '' && !existe) {
              this.estadoSubsidioMCYList.unshift(this.form.controls['EstadoSubsidioMCY'].value);
            }

            this.estadoSubsidioMCYList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 5) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'HoradeEntrega')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.horaEntregaList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['HoradeEntrega'].value){
                existe = true;
              }
            }

            if(this.form.controls['HoradeEntrega'].value != null && this.form.controls['HoradeEntrega'].value != '' && !existe){
              this.horaEntregaList.unshift(this.form.controls['HoradeEntrega'].value);
            }

            this.horaEntregaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 5) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CaidaEntregas')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.caidaEntregasList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CaidaEntregas'].value){
                existe = true;
              }
            }

            if(this.form.controls['CaidaEntregas'].value != null && this.form.controls['CaidaEntregas'].value != '' && !existe){
              this.caidaEntregasList.unshift(this.form.controls['CaidaEntregas'].value);
            }

            this.caidaEntregasList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 5) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AnalistaEntregas')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.analistaEntregasList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['AnalistaEntregas'].value) {
                existe = true;
              }
            }

            if (this.form.controls['AnalistaEntregas'].value != null && this.form.controls['AnalistaEntregas'].value != '' && !existe) {
              this.analistaEntregasList.unshift(this.form.controls['AnalistaEntregas'].value);
            }

            this.analistaEntregasList.unshift('Vacio');
          }
        )
    }


    if (this.reportType == 7) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoEscriturado')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoEscrituradoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoEscriturado'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoEscriturado'].value != null && this.form.controls['EstadoEscriturado'].value != '' && !existe){
              this.estadoEscrituradoList.unshift(this.form.controls['EstadoEscriturado'].value);
            }

            this.estadoEscrituradoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 7) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TipificacionMesAnterior')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tipificacionMesAnteriorList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['TipificacionMesAnterior'].value) {
                existe = true;
              }
            }

            if (this.form.controls['TipificacionMesAnterior'].value != null && this.form.controls['TipificacionMesAnterior'].value != '' && !existe) {
              this.tipificacionMesAnteriorList.unshift(this.form.controls['TipificacionMesAnterior'].value);
            }

            this.tipificacionMesAnteriorList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 7) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'Operacion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.operacionList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['Operacion'].value) {
                existe = true;
              }
            }

            if (this.form.controls['Operacion'].value != null && this.form.controls['Operacion'].value != '' && !existe) {
              this.operacionList.unshift(this.form.controls['Operacion'].value);
            }

            this.operacionList.unshift('Vacio');
          }
        )
    }


    if (this.reportType == 8) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TipificacionCorreccionesCtl')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tipificacionCorreccionesCtlList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['TipificacionCorreccionesCtl'].value){
                existe = true;
              }
            }

            if(this.form.controls['TipificacionCorreccionesCtl'].value != null && this.form.controls['TipificacionCorreccionesCtl'].value != '' && !existe){
              this.tipificacionCorreccionesCtlList.unshift(this.form.controls['TipificacionCorreccionesCtl'].value);
            }

            this.tipificacionCorreccionesCtlList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 9) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'Frpl')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.frplList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['Frpl'].value){
                existe = true;
              }
            }

            if(this.form.controls['Frpl'].value != null && this.form.controls['Frpl'].value != '' && !existe){
              this.frplList.unshift(this.form.controls['Frpl'].value);
            }

            this.frplList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 9) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'QuienFirmaEsfp')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.quienFirmaEsfpList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['QuienFirmaEsfp'].value){
                existe = true;
              }
            }

            if(this.form.controls['QuienFirmaEsfp'].value != null && this.form.controls['QuienFirmaEsfp'].value != '' && !existe){
              this.quienFirmaEsfpList.unshift(this.form.controls['QuienFirmaEsfp'].value);
            }

            this.quienFirmaEsfpList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 9) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoEsfpFrpl')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoEsfpFrplList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoEsfpFrpl'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoEsfpFrpl'].value != null && this.form.controls['EstadoEsfpFrpl'].value != '' && !existe){
              this.estadoEsfpFrplList.unshift(this.form.controls['EstadoEsfpFrpl'].value);
            }

            this.estadoEsfpFrplList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 9) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoAbogado')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoAbogadoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoAbogado'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoAbogado'].value != null && this.form.controls['EstadoAbogado'].value != '' && !existe){
              this.estadoAbogadoList.unshift(this.form.controls['EstadoAbogado'].value);
            }

            this.estadoAbogadoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 9) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'PresentoCambio')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.presentoCambioList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['PresentoCambio'].value){
                existe = true;
              }
            }

            if(this.form.controls['PresentoCambio'].value != null && this.form.controls['PresentoCambio'].value != '' && !existe){
              this.presentoCambioList.unshift(this.form.controls['PresentoCambio'].value);
            }

            this.presentoCambioList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 9) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoPyS')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoPySList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoPyS'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoPyS'].value != null && this.form.controls['EstadoPyS'].value != '' && !existe){
              this.estadoPySList.unshift(this.form.controls['EstadoPyS'].value);
            }

            this.estadoPySList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 9) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AnalistaACargoNotaria')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.analistaACargoNotariaList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['AnalistaACargoNotaria'].value){
                existe = true;
              }
            }

            if(this.form.controls['AnalistaACargoNotaria'].value != null && this.form.controls['AnalistaACargoNotaria'].value != '' && !existe){
              this.analistaACargoNotariaList.unshift(this.form.controls['AnalistaACargoNotaria'].value);
            }

            this.analistaACargoNotariaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 10) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CampanasEspeciales')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.campanasEspecialesList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CampanasEspeciales'].value){
                existe = true;
              }
            }

            if(this.form.controls['CampanasEspeciales'].value != null && this.form.controls['CampanasEspeciales'].value != '' && !existe){
              this.campanasEspecialesList.unshift(this.form.controls['CampanasEspeciales'].value);
            }

            this.campanasEspecialesList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 10) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'NotificacionesNegocio')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.notificacionesNegocioList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['NotificacionesNegocio'].value){
                existe = true;
              }
            }

            if(this.form.controls['NotificacionesNegocio'].value != null && this.form.controls['NotificacionesNegocio'].value != '' && !existe){
              this.notificacionesNegocioList.unshift(this.form.controls['NotificacionesNegocio'].value);
            }

            this.notificacionesNegocioList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 10) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalRenovacion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalRenovacionList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CausalRenovacion'].value){
                existe = true;
              }
            }

            if(this.form.controls['CausalRenovacion'].value != null && this.form.controls['CausalRenovacion'].value != '' && !existe){
              this.causalRenovacionList.unshift(this.form.controls['CausalRenovacion'].value);
            }

            this.causalRenovacionList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 10) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoPoderAnalista')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoPoderAnalistaList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoPoderAnalista'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoPoderAnalista'].value != null && this.form.controls['EstadoPoderAnalista'].value != '' && !existe){
              this.estadoPoderAnalistaList.unshift(this.form.controls['EstadoPoderAnalista'].value);
            }

            this.estadoPoderAnalistaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 10) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TipoDeNovedad')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tipoDeNovedadList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['TipoDeNovedad'].value){
                existe = true;
              }
            }

            if(this.form.controls['TipoDeNovedad'].value != null && this.form.controls['TipoDeNovedad'].value != '' && !existe){
              this.tipoDeNovedadList.unshift(this.form.controls['TipoDeNovedad'].value);
            }

            this.tipoDeNovedadList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 10) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'Analista_Outsourcing')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.analistaOutsourcingList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['Analista_Outsourcing'].value){
                existe = true;
              }
            }

            if(this.form.controls['Analista_Outsourcing'].value != null && this.form.controls['Analista_Outsourcing'].value != '' && !existe){
              this.analistaOutsourcingList.unshift(this.form.controls['Analista_Outsourcing'].value);
            }

            this.analistaOutsourcingList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 11) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CaidaEntregas')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.caidaEntregasList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CaidaEntregas'].value){
                existe = true;
              }
            }

            if(this.form.controls['CaidaEntregas'].value != null && this.form.controls['CaidaEntregas'].value != '' && !existe){
              this.caidaEntregasList.unshift(this.form.controls['CaidaEntregas'].value);
            }


            this.caidaEntregasList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 11) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TubosDeGestion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tubosDeGestionList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['TubosDeGestion'].value){
                existe = true;
              }
            }

            if(this.form.controls['TubosDeGestion'].value != null && this.form.controls['TubosDeGestion'].value != '' && !existe){
              this.tubosDeGestionList.unshift(this.form.controls['TubosDeGestion'].value);
            }

            this.tubosDeGestionList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 11) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoPromesas')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoPromesasList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoPromesas'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoPromesas'].value != null && this.form.controls['EstadoPromesas'].value != '' && !existe){
              this.estadoPromesasList.unshift(this.form.controls['EstadoPromesas'].value);
            }


            this.estadoPromesasList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 11) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'RecorridoJuridico')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.recorridoJuridicoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['RecorridoJuridico'].value){
                existe = true;
              }
            }

            if(this.form.controls['RecorridoJuridico'].value != null && this.form.controls['RecorridoJuridico'].value != '' && !existe){
              this.recorridoJuridicoList.unshift(this.form.controls['RecorridoJuridico'].value);
            }


            this.recorridoJuridicoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 11) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ClienteExterior')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.clienteExteriorList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['ClienteExterior'].value){
                existe = true;
              }
            }

            if(this.form.controls['ClienteExterior'].value != null && this.form.controls['ClienteExterior'].value != '' && !existe){
              this.clienteExteriorList.unshift(this.form.controls['ClienteExterior'].value);
            }


            this.clienteExteriorList.unshift('Vacio');
          }
        )
    }


    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'PrioridadDelNegocio')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.prioridadDelNegocioList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['PrioridadDelNegocio'].value){
                existe = true;
              }
            }

            if(this.form.controls['PrioridadDelNegocio'].value != null && this.form.controls['PrioridadDelNegocio'].value != '' && !existe){
              this.prioridadDelNegocioList.unshift(this.form.controls['PrioridadDelNegocio'].value);
            }

            this.prioridadDelNegocioList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ResponsableQueReporta')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.responsableQueReportaList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['ResponsableQueReporta'].value){
                existe = true;
              }
            }

            if(this.form.controls['ResponsableQueReporta'].value != null && this.form.controls['ResponsableQueReporta'].value != '' && !existe){
              this.responsableQueReportaList.unshift(this.form.controls['ResponsableQueReporta'].value);
            }

            this.responsableQueReportaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'NotificacionesCarta')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.notificacionesCartaList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['NotificacionesCarta'].value) {
                existe = true;
              }
            }

            if (this.form.controls['NotificacionesCarta'].value != null && this.form.controls['NotificacionesCarta'].value != '' && !existe) {
              this.notificacionesCartaList.unshift(this.form.controls['NotificacionesCarta'].value);
            }

            this.notificacionesCartaList.unshift('Vacio');
          }
        )
    }

    //
    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'Fuente')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.fuenteList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['Fuente'].value){
                existe = true;
              }
            }

            if(this.form.controls['Fuente'].value != null && this.form.controls['Fuente'].value != '' && !existe){
              this.fuenteList.unshift(this.form.controls['Fuente'].value);
            }

            this.fuenteList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AnalistaNegociosEnRiesgo')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.analistaNegociosEnRiesgoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['AnalistaNegociosEnRiesgo'].value){
                existe = true;
              }
            }

            if(this.form.controls['AnalistaNegociosEnRiesgo'].value != null && this.form.controls['AnalistaNegociosEnRiesgo'].value != '' && !existe){
              this.analistaNegociosEnRiesgoList.unshift(this.form.controls['AnalistaNegociosEnRiesgo'].value);
            }

            this.analistaNegociosEnRiesgoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'DocumentoFirmado')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.documentoFirmadoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['DocumentoFirmado'].value){
                existe = true;
              }
            }

            if(this.form.controls['DocumentoFirmado'].value != null && this.form.controls['DocumentoFirmado'].value != '' && !existe){
              this.documentoFirmadoList.unshift(this.form.controls['DocumentoFirmado'].value);
            }

            this.documentoFirmadoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoDelEncargo')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoDelEncargoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoDelEncargo'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoDelEncargo'].value != null && this.form.controls['EstadoDelEncargo'].value != '' && !existe){
              this.estadoDelEncargoList.unshift(this.form.controls['EstadoDelEncargo'].value);
            }

            this.estadoDelEncargoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TipoDeClausulaSiAplicaParaEncargo')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tipoDeClausulaSiAplicaParaEncargoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['TipoDeClausulaSiAplicaParaEncargo'].value){
                existe = true;
              }
            }

            if(this.form.controls['TipoDeClausulaSiAplicaParaEncargo'].value != null && this.form.controls['TipoDeClausulaSiAplicaParaEncargo'].value != '' && !existe){
              this.tipoDeClausulaSiAplicaParaEncargoList.unshift(this.form.controls['TipoDeClausulaSiAplicaParaEncargo'].value);
            }

            this.tipoDeClausulaSiAplicaParaEncargoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalFamilia')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalFamiliaList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CausalFamilia'].value){
                existe = true;
              }
            }

            if(this.form.controls['CausalFamilia'].value != null && this.form.controls['CausalFamilia'].value != '' && !existe){
              this.causalFamiliaList.unshift(this.form.controls['CausalFamilia'].value);
            }

            this.causalFamiliaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'SubsanadoAl100')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.subsanadoAl100List = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['SubsanadoAl100'].value){
                existe = true;
              }
            }

            if(this.form.controls['SubsanadoAl100'].value != null && this.form.controls['SubsanadoAl100'].value != '' && !existe){
              this.subsanadoAl100List.unshift(this.form.controls['SubsanadoAl100'].value);
            }


            this.subsanadoAl100List.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'Soportes')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.soportesList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['Soportes'].value){
                existe = true;
              }
            }

            if(this.form.controls['Soportes'].value != null && this.form.controls['Soportes'].value != '' && !existe){
              this.soportesList.unshift(this.form.controls['Soportes'].value);
            }


            this.soportesList.unshift('Vacio');
          }
        )
    }
    //
    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'NuevaSolicitudEnOtroBanco')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.nuevaSolicitudEnOtroBancoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['NuevaSolicitudEnOtroBanco'].value){
                existe = true;
              }
            }

            if(this.form.controls['NuevaSolicitudEnOtroBanco'].value != null && this.form.controls['NuevaSolicitudEnOtroBanco'].value != '' && !existe){
              this.nuevaSolicitudEnOtroBancoList.unshift(this.form.controls['NuevaSolicitudEnOtroBanco'].value);
            }


            this.nuevaSolicitudEnOtroBancoList.unshift('Vacio');
          }
        )
    }
    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalManejoDeAuxiliar')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalManejoDeAuxiliarList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CausalManejoDeAuxiliar'].value){
                existe = true;
              }
            }

            if(this.form.controls['CausalManejoDeAuxiliar'].value != null && this.form.controls['CausalManejoDeAuxiliar'].value != '' && !existe){
              this.causalManejoDeAuxiliarList.unshift(this.form.controls['CausalManejoDeAuxiliar'].value);
            }


            this.causalManejoDeAuxiliarList.unshift('Vacio');
          }
        )
    }
    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalDeRiesgo')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalDeRiesgoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CausalDeRiesgo'].value){
                existe = true;
              }
            }

            if(this.form.controls['CausalDeRiesgo'].value != null && this.form.controls['CausalDeRiesgo'].value != '' && !existe){
              this.causalDeRiesgoList.unshift(this.form.controls['CausalDeRiesgo'].value);
            }


            this.causalDeRiesgoList.unshift('Vacio');
          }
        )
    }
    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalDeRiesgos2')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalDeRiesgos2List = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CausalDeRiesgos2'].value){
                existe = true;
              }
            }

            if(this.form.controls['CausalDeRiesgos2'].value != null && this.form.controls['CausalDeRiesgos2'].value != '' && !existe){
              this.causalDeRiesgos2List.unshift(this.form.controls['CausalDeRiesgos2'].value);
            }


            this.causalDeRiesgos2List.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalDeRiesgos3')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalDeRiesgos3List = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CausalDeRiesgos3'].value){
                existe = true;
              }
            }

            if(this.form.controls['CausalDeRiesgos3'].value != null && this.form.controls['CausalDeRiesgos3'].value != '' && !existe){
              this.causalDeRiesgos3List.unshift(this.form.controls['CausalDeRiesgos3'].value);
            }


            this.causalDeRiesgos3List.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalDeRiesgos4')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalDeRiesgos4List = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['CausalDeRiesgos4'].value){
                existe = true;
              }
            }

            if(this.form.controls['CausalDeRiesgos4'].value != null && this.form.controls['CausalDeRiesgos4'].value != '' && !existe){
              this.causalDeRiesgos4List.unshift(this.form.controls['CausalDeRiesgos4'].value);
            }


            this.causalDeRiesgos4List.unshift('Vacio');
          }
        )
    }


    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstrategiaDesistimiento')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estrategiaDesistimientoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstrategiaDesistimiento'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstrategiaDesistimiento'].value != null && this.form.controls['EstrategiaDesistimiento'].value != '' && !existe){
              this.estrategiaDesistimientoList.unshift(this.form.controls['EstrategiaDesistimiento'].value);
            }


            this.estrategiaDesistimientoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 12) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'NegocioMetaAnioActual')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.negocioMetaAnioActualList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['NegocioMetaAnioActual'].value){
                existe = true;
              }
            }

            if(this.form.controls['NegocioMetaAnioActual'].value != null && this.form.controls['NegocioMetaAnioActual'].value != '' && !existe){
              this.negocioMetaAnioActualList.unshift(this.form.controls['NegocioMetaAnioActual'].value);
            }


            this.negocioMetaAnioActualList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoCoordinador')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoCoordinadorList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoCoordinador'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoCoordinador'].value != null && this.form.controls['EstadoCoordinador'].value != '' && !existe){
              this.estadoCoordinadorList.unshift(this.form.controls['EstadoCoordinador'].value);
            }


            this.estadoCoordinadorList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoAnalista')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoAnalistaList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoAnalista'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoAnalista'].value != null && this.form.controls['EstadoAnalista'].value != '' && !existe){
              this.estadoAnalistaList.unshift(this.form.controls['EstadoAnalista'].value);
            }


            this.estadoAnalistaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TuboGestion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tuboGestionList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['TuboGestion'].value){
                existe = true;
              }
            }

            if(this.form.controls['TuboGestion'].value != null && this.form.controls['TuboGestion'].value != '' && !existe){
              this.tuboGestionList.unshift(this.form.controls['TuboGestion'].value);
            }


            this.tuboGestionList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AnalistaAsignado')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.analistaAsignadoList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['AnalistaAsignado'].value){
                existe = true;
              }
            }

            if(this.form.controls['AnalistaAsignado'].value != null && this.form.controls['AnalistaAsignado'].value != '' && !existe){
              this.analistaAsignadoList.unshift(this.form.controls['AnalistaAsignado'].value);
            }


            this.analistaAsignadoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ClasificacionSisben')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.clasificacionSisbenList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['ClasificacionSisben'].value){
                existe = true;
              }
            }

            if(this.form.controls['ClasificacionSisben'].value != null && this.form.controls['ClasificacionSisben'].value != '' && !existe){
              this.clasificacionSisbenList.unshift(this.form.controls['ClasificacionSisben'].value);
            }


            this.clasificacionSisbenList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'SimmularConMCY')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.simmularConMCYList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['SimmularConMCY'].value){
                existe = true;
              }
            }

            if(this.form.controls['SimmularConMCY'].value != null && this.form.controls['SimmularConMCY'].value != '' && !existe){
              this.simmularConMCYList.unshift(this.form.controls['SimmularConMCY'].value);
            }

            this.simmularConMCYList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoSubsidioMCY')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoSubsidioMCYList = response;
            AppComponent.displayLoading = false;

            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoSubsidioMCY'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoSubsidioMCY'].value != null && this.form.controls['EstadoSubsidioMCY'].value != '' && !existe){
              this.estadoSubsidioMCYList.unshift(this.form.controls['EstadoSubsidioMCY'].value);
            }

            this.estadoSubsidioMCYList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ObservacionCampanaEnrolamientoSisben')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.observacionCampanaEnrolamientoSisbenList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ObservacionCampanaEnrolamientoSisben'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ObservacionCampanaEnrolamientoSisben'].value != null && this.form.controls['ObservacionCampanaEnrolamientoSisben'].value != '' && !existe) {
              this.observacionCampanaEnrolamientoSisbenList.unshift(this.form.controls['ObservacionCampanaEnrolamientoSisben'].value);
            }

            this.observacionCampanaEnrolamientoSisbenList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'NegocioConCierreFinanciero')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.negocioConCierreFinancieroList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['NegocioConCierreFinanciero'].value) {
                existe = true;
              }
            }

            if (this.form.controls['NegocioConCierreFinanciero'].value != null && this.form.controls['NegocioConCierreFinanciero'].value != '' && !existe) {
              this.negocioConCierreFinancieroList.unshift(this.form.controls['NegocioConCierreFinanciero'].value);
            }

            this.negocioConCierreFinancieroList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'BonoEstrategiaCredito')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.bonoEstrategiaCreditoList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['BonoEstrategiaCredito'].value) {
                existe = true;
              }
            }

            if (this.form.controls['BonoEstrategiaCredito'].value != null && this.form.controls['BonoEstrategiaCredito'].value != '' && !existe) {
              this.bonoEstrategiaCreditoList.unshift(this.form.controls['BonoEstrategiaCredito'].value);
            }

            this.bonoEstrategiaCreditoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ClienteNoAcepta')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.clienteNoAceptaList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ClienteNoAcepta'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ClienteNoAcepta'].value != null && this.form.controls['ClienteNoAcepta'].value != '' && !existe) {
              this.clienteNoAceptaList.unshift(this.form.controls['ClienteNoAcepta'].value);
            }

            this.clienteNoAceptaList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'Agenda')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.agendaList = response;
            AppComponent.displayLoading = false;
            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['Agenda'].value) {
                existe = true;
              }
            }
            if (this.form.controls['Agenda'].value != null && this.form.controls['Agenda'].value != '' && !existe) {
              this.agendaList.unshift(this.form.controls['Agenda'].value);
            }
            this.agendaList.unshift('Vacio');
          }
        )
    }
    if (this.reportType == 13) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'SemaforoSatisfaccion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.semaforoSatisfaccionList = response;
            AppComponent.displayLoading = false;
            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['SemaforoSatisfaccion'].value) {
                existe = true;
              }
            }
            if (this.form.controls['SemaforoSatisfaccion'].value != null && this.form.controls['SemaforoSatisfaccion'].value != '' && !existe) {
              this.semaforoSatisfaccionList.unshift(this.form.controls['SemaforoSatisfaccion'].value);
            }
            this.semaforoSatisfaccionList.unshift('Vacio');
          }
        )
    }


    if (this.reportType == 14) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'FormaDevolucion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.formaDevolucionList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['FormaDevolucion'].value) {
                existe = true;
              }
            }

            if (this.form.controls['FormaDevolucion'].value != null && this.form.controls['FormaDevolucion'].value != '' && !existe) {
              this.formaDevolucionList.unshift(this.form.controls['FormaDevolucion'].value);
            }

            this.formaDevolucionList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 14) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EntidadEncargadaDevolucion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.entidadEncargadaDevolucionList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['EntidadEncargadaDevolucion'].value) {
                existe = true;
              }
            }

            if (this.form.controls['EntidadEncargadaDevolucion'].value != null && this.form.controls['EntidadEncargadaDevolucion'].value != '' && !existe) {
              this.entidadEncargadaDevolucionList.unshift(this.form.controls['EntidadEncargadaDevolucion'].value);
            }

            this.entidadEncargadaDevolucionList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 14) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoDesistimiento')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoDesistimientoList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['EstadoDesistimiento'].value) {
                existe = true;
              }
            }

            if (this.form.controls['EstadoDesistimiento'].value != null && this.form.controls['EstadoDesistimiento'].value != '' && !existe) {
              this.estadoDesistimientoList.unshift(this.form.controls['EstadoDesistimiento'].value);
            }

            this.estadoDesistimientoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 14) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TipoDesistimiento')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tipoDesistimientoList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['TipoDesistimiento'].value) {
                existe = true;
              }
            }

            if (this.form.controls['TipoDesistimiento'].value != null && this.form.controls['TipoDesistimiento'].value != '' && !existe) {
              this.tipoDesistimientoList.unshift(this.form.controls['TipoDesistimiento'].value);
            }

            this.tipoDesistimientoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 14) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoFinal')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoFinalList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['EstadoFinal'].value) {
                existe = true;
              }
            }

            if (this.form.controls['EstadoFinal'].value != null && this.form.controls['EstadoFinal'].value != '' && !existe) {
              this.estadoFinalList.unshift(this.form.controls['EstadoFinal'].value);
            }

            this.estadoFinalList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'NegocioFenalpagare')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.negocioFenalpagareList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['NegocioFenalpagare'].value) {
                existe = true;
              }
            }

            if (this.form.controls['NegocioFenalpagare'].value != null && this.form.controls['NegocioFenalpagare'].value != '' && !existe) {
              this.negocioFenalpagareList.unshift(this.form.controls['NegocioFenalpagare'].value);
            }

            this.negocioFenalpagareList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CasosAutorizacionEspecial')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.casosAutorizacionEspecialList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['CasosAutorizacionEspecial'].value) {
                existe = true;
              }
            }

            if (this.form.controls['CasosAutorizacionEspecial'].value != null && this.form.controls['CasosAutorizacionEspecial'].value != '' && !existe) {
              this.casosAutorizacionEspecialList.unshift(this.form.controls['CasosAutorizacionEspecial'].value);
            }

            this.casosAutorizacionEspecialList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AjusteAplicacionPago')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.ajusteAplicacionPagoList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['AjusteAplicacionPago'].value) {
                existe = true;
              }
            }

            if (this.form.controls['AjusteAplicacionPago'].value != null && this.form.controls['AjusteAplicacionPago'].value != '' && !existe) {
              this.ajusteAplicacionPagoList.unshift(this.form.controls['AjusteAplicacionPago'].value);
            }

            this.ajusteAplicacionPagoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'TipoSolicitud')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.tipoSolicitudList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['TipoSolicitud'].value) {
                existe = true;
              }
            }

            if (this.form.controls['TipoSolicitud'].value != null && this.form.controls['TipoSolicitud'].value != '' && !existe) {
              this.tipoSolicitudList.unshift(this.form.controls['TipoSolicitud'].value);
            }

            this.tipoSolicitudList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ProcesoPendienteCartera')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.procesoPendienteCarteraList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ProcesoPendienteCartera'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ProcesoPendienteCartera'].value != null && this.form.controls['ProcesoPendienteCartera'].value != '' && !existe) {
              this.procesoPendienteCarteraList.unshift(this.form.controls['ProcesoPendienteCartera'].value);
            }

            this.procesoPendienteCarteraList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ResponsableCartera')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.responsableCarteraList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ResponsableCartera'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ResponsableCartera'].value != null && this.form.controls['ResponsableCartera'].value != '' && !existe) {
              this.responsableCarteraList.unshift(this.form.controls['ResponsableCartera'].value);
            }

            this.responsableCarteraList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ObservacionCartera')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.observacionCarteraList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ObservacionCartera'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ObservacionCartera'].value != null && this.form.controls['ObservacionCartera'].value != '' && !existe) {
              this.observacionCarteraList.unshift(this.form.controls['ObservacionCartera'].value);
            }

            this.observacionCarteraList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'AplicacionBonoDescuento')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.aplicacionBonoDescuentoList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['AplicacionBonoDescuento'].value) {
                existe = true;
              }
            }

            if (this.form.controls['AplicacionBonoDescuento'].value != null && this.form.controls['AplicacionBonoDescuento'].value != '' && !existe) {
              this.aplicacionBonoDescuentoList.unshift(this.form.controls['AplicacionBonoDescuento'].value);
            }

            this.aplicacionBonoDescuentoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoPyS')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoPySList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['EstadoPyS'].value) {
                existe = true;
              }
            }

            if (this.form.controls['EstadoPyS'].value != null && this.form.controls['EstadoPyS'].value != '' && !existe) {
              this.estadoPySList.unshift(this.form.controls['EstadoPyS'].value);
            }

            this.estadoPySList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'CausalDevolucion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.causalDevolucionList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['CausalDevolucion'].value) {
                existe = true;
              }
            }

            if (this.form.controls['CausalDevolucion'].value != null && this.form.controls['CausalDevolucion'].value != '' && !existe) {
              this.causalDevolucionList.unshift(this.form.controls['CausalDevolucion'].value);
            }

            this.causalDevolucionList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ObservacionesAnalistaTramites')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.observacionesAnalistaTramitesList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ObservacionesAnalistaTramites'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ObservacionesAnalistaTramites'].value != null && this.form.controls['ObservacionesAnalistaTramites'].value != '' && !existe) {
              this.observacionesAnalistaTramitesList.unshift(this.form.controls['ObservacionesAnalistaTramites'].value);
            }

            this.observacionesAnalistaTramitesList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'DocumentoGenerado')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.documentoGeneradoList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['DocumentoGenerado'].value) {
                existe = true;
              }
            }

            if (this.form.controls['DocumentoGenerado'].value != null && this.form.controls['DocumentoGenerado'].value != '' && !existe) {
              this.documentoGeneradoList.unshift(this.form.controls['DocumentoGenerado'].value);
            }

            this.documentoGeneradoList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 15) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'ResponsableCarteraDos')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.responsableCarteraDosList = response;
            AppComponent.displayLoading = false;

            let existe: boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if (element == this.form.controls['ResponsableCarteraDos'].value) {
                existe = true;
              }
            }

            if (this.form.controls['ResponsableCarteraDos'].value != null && this.form.controls['ResponsableCarteraDos'].value != '' && !existe) {
              this.responsableCarteraDosList.unshift(this.form.controls['ResponsableCarteraDos'].value);
            }

            this.responsableCarteraDosList.unshift('Vacio');
          }
        )
    }

    if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoRecaudo')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoRecaudoList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoRecaudo'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoRecaudo'].value != null && this.form.controls['EstadoRecaudo'].value != '' && !existe){
              this.estadoRecaudoList.unshift(this.form.controls['EstadoRecaudo'].value);
            }
            
            this.estadoRecaudoList.unshift('Vacio');
          }
        )
    }
if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoCredito')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoCreditoList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoCredito'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoCredito'].value != null && this.form.controls['EstadoCredito'].value != '' && !existe){
              this.estadoCreditoList.unshift(this.form.controls['EstadoCredito'].value);
            }
            
            this.estadoCreditoList.unshift('Vacio');
          }
        )
    }
if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoPromesa')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoPromesaList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoPromesa'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoPromesa'].value != null && this.form.controls['EstadoPromesa'].value != '' && !existe){
              this.estadoPromesaList.unshift(this.form.controls['EstadoPromesa'].value);
            }
            
            this.estadoPromesaList.unshift('Vacio');
          }
        )
    }
if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoLegalizacion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoLegalizacionList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoLegalizacion'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoLegalizacion'].value != null && this.form.controls['EstadoLegalizacion'].value != '' && !existe){
              this.estadoLegalizacionList.unshift(this.form.controls['EstadoLegalizacion'].value);
            }
            
            this.estadoLegalizacionList.unshift('Vacio');
          }
        )
    }
if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoEscrituracion')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoEscrituracionList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoEscrituracion'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoEscrituracion'].value != null && this.form.controls['EstadoEscrituracion'].value != '' && !existe){
              this.estadoEscrituracionList.unshift(this.form.controls['EstadoEscrituracion'].value);
            }
            
            this.estadoEscrituracionList.unshift('Vacio');
          }
        )
    }
if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoEntrega')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoEntregaList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoEntrega'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoEntrega'].value != null && this.form.controls['EstadoEntrega'].value != '' && !existe){
              this.estadoEntregaList.unshift(this.form.controls['EstadoEntrega'].value);
            }
            
            this.estadoEntregaList.unshift('Vacio');
          }
        )
    }
if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'EstadoPoderes')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.estadoPoderesList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['EstadoPoderes'].value){
                existe = true;
              }
            }

            if(this.form.controls['EstadoPoderes'].value != null && this.form.controls['EstadoPoderes'].value != '' && !existe){
              this.estadoPoderesList.unshift(this.form.controls['EstadoPoderes'].value);
            }
            
            this.estadoPoderesList.unshift('Vacio');
          }
        )
    }
if (this.reportType == 17) {
      AppComponent.displayLoading = true;
      this.legalizacionService.getOptionListModal(toolName, 'MotivoRiesgo')
        .subscribe(
          (response: any) => {
            console.log(response);
            this.motivoRiesgoList = response;
            AppComponent.displayLoading = false;
            
            let existe : boolean = false;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              if(element == this.form.controls['MotivoRiesgo'].value){
                existe = true;
              }
            }

            if(this.form.controls['MotivoRiesgo'].value != null && this.form.controls['MotivoRiesgo'].value != '' && !existe){
              this.motivoRiesgoList.unshift(this.form.controls['MotivoRiesgo'].value);
            }
            
            this.motivoRiesgoList.unshift('Vacio');
          }
        )
    }



  }

  ngOnInit(): void {
    let role = localStorage.getItem('role');
    console.log('role', role);

    if (role == 'Administrador') {
      this.disableValidation = {
        FechadeEntrega: false,
        HoradeEntrega: false,
        CreacionCaso: false,
        Apoderado: false,
        EstadoCoordinador: false,
        ObservacionCoordinador: false,
        EstadoAnalista: false,
        ObservacionAnalista: false,
        Arquitecta: false,

        FechaSeguimientoCoordinador: false,
        FechaSeguimientoAnalista: false,
        FechaAsignacion: false,
        AsignacionAnalista: false,
        AnalistaVarado: false,
        EstadoAnalistaVarado: false,

        Bloqueante: false,

        Comentarios: false,

        TipificacionCorreccionesCtl: false,
        AnalistaTrazabilidad: false,

        TipoInconsistencia: false,
        ComunicadosEnviados: false,

        AuxOrdenesEscrituracion: false,
        Frpl: false,
        QuienFirmaEsfp: false,
        EstadoEsfpFrpl: false,
        EstadoAbogado: false,
        ObservacionAbogado: false,
        PresentoCambio: false,
        CualFueElCambio: false,
        NoPredialNacional: false,
        NumeroId: false,
        IdMunicipio: false,
        RadicacionOrdenPagoPySPredial: false,
        FechaEstimadaDePyS: false,
        TipoPyS: false,
        MunicipioPyS: false,
        EstadoPyS: false,
        EstadoOrdenes: false,
        ObservacionAnalistaACargo: false,
        AnalistaACargoNotaria: false,

        TipoDeNovedad: false,
        Analista_Outsourcing: false,

        CampanasEspeciales: false,
        FechaSeguimientoBanco: false,
        EstadoBanco: false,
        ObservacionBanco: false,
        FechaUltimaNotificacion: false,
        FechaCompromiso: false,
        NotificacionesNegocio: false,
        CausalRenovacion: false,
        EstadoPoderAnalista: false,
        AsignacionAnalistaPromesas: false,

        FechaAcuerdoProximoPago: false,
        MontoPactado: false,
        LlamadaNo1: false,
        LlamadaNo2: false,
        Fenalco1erBarrido: false,
        Fenalco2doBarrido: false,
        LlamadaNo3: false,
        LlamadaNo4: false,
        LlamadaNo5: false,
        EstadoEscriturado: false,
        TipificacionMesAnterior: false,
        FechaEnvioSMS: false,
        FechaNotificacionAlerta: false,
        FechaCarta1: false,
        FechaCarta2: false,
        FechaCarta3: false,
        AnalistaRecaudo: false,
        Operacion: false,
        LlamadaNo_1: false,
        LlamadaNo_2: false,
        LlamadaNo_3: false,


        CaidaEntregas: false,
        AnalistaEntregas: false,
        TubosDeGestion: false,
        EstadoPromesas: false,
        FechaPredial: false,
        FechaEstampilla: false,
        FechaPoderFidubogota: false,
        RecorridoJuridico: false,
        ClienteExterior: false,
        FechaAsigna: false,
        FechaMetaComite: false,
        FechaMetaCelula: false,
        AnalistaEscrituracion: false,


        ID_PA: false,
        FechaSubsanado: false,
        FechaSeguimientoAnalista2: false,
        FechaInicialSeguimientoAnalista: false,
        PrioridadDelNegocio: false,
        MesDeGestion: false,
        ResponsableQueReporta: false,
        NotificacionesCarta: false,
        Fuente: false,
        AnalistaNegociosEnRiesgo: false,
        FechaCompromisoAnalista: false,
        DocumentoFirmado: false,
        EstadoDelEncargo: false,
        TipoDeClausulaSiAplicaParaEncargo: false,
        CausalFamilia: false,
        SubsanadoAl100: false,
        Soportes: false,
        ObservacionesDeNegociosEnRiesgo: false,
        BancoDeCreditoNegado: false,
        NuevaSolicitudEnOtroBanco: false,
        NombreDelBanco: false,
        ValorDeSancion: false,
        EstadoParaDesistir: false,
        AsesorDelBanco: false,
        CausalManejoDeAuxiliar: false,
        TiempoRespuesta: false,
        CreditoAprobado: false,
        CausalDeRiesgo: false,
        CausalDeRiesgos2: false,
        CausalDeRiesgos3: false,
        CausalDeRiesgos4: false,
        EstrategiaDesistimiento: false,
        NegocioMetaAnioActual: false,

        FechaEstadoCoordinador: false,
        FechaEstadoAnalista: false,

        FechaGestion: false,
        TuboGestion: false,
        AnalistaAsignado: false,
        Compromiso: false,
        FechaProxGestion: false,
        NegocioConCierreFinanciero: false,
        RecursosPropios: false,
        IngresoFamiliar: false,
        ClasificacionSisben: false,
        SimmularConMCY: false,
        AccionRecomendada: false,
        EstadoSubsidioMCY: false,
        ValorCreditoAcordado: false,
        ObservacionCampanaEnrolamientoSisben: false,
        AvanceObra: false,
        BonoEstrategiaCredito: false,
        ClienteNoAcepta: false,
        FechaInicioEstado: false,
        FechaAgenda: false,
        Agenda: false,
        SemaforoSatisfaccion: false,
        NumeroRadicadoEnrolamiento: false,
        FechaEnrolamiento: false,
        PostuladoMCY: false,

        Indemnizacion: false,
        FormaDevolucion: false,
        Banco: false,
        NumeroCuenta: false,
        TipoCuenta: false,
        EntidadEncargadaDevolucion: false,
        EstadoDesistimiento: false,
        TipoDesistimiento: false,
        FechaEnvioCertificacionBancaria: false,
        FechaElaboracionMemorando: false,
        NumeroMemorando: false,
        EstadoFinal: false,
        Observaciones: false,
        NotaMemoFidudavivienda: false,
        Asistente: false,
        VoboAnalista: false,
        NegocioFenalpagare: false,
        CasosAutorizacionEspecial: false,
        AjusteAplicacionPago: false,
        TipoSolicitud: false,
        ProcesoPendienteCartera: false,
        ResponsableCartera: false,
        ObservacionCartera: false,
        AplicacionBonoDescuento: false,
        CausalDevolucion: false,
        ObservacionesAnalistaTramites: false,
        DocumentoGenerado: false,
        ResponsableCarteraDos: false,
        ValorBonoDescuento: false,
        LiquidadorGastosEscrituracion: false,
        MotivoDevolucion: false,
        FechaSolicitud: false,
        FechaRevision: false,
        FechaObservacionAjustes: false,
        FechaEvacuadoPyS: false,
        FechaNotificacionObsTramites: false,
        FechaDevolucionTramites: false,

        AsesorSeguimiento1: false,
        AsesorSeguimiento2: false,
        NotificacionCarta: false,
        ObservacionAsesor: false,
        EstadoRecaudo: false,
        EstadoCredito: false,
        EstadoPromesa: false,
        EstadoLegalizacion: false,
        EstadoEscrituracion: false,
        EstadoEntrega: false,
        EstadoPoderes: false,
        MotivoRiesgo: false,

      }
    } else {
      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.LEGALIZACION) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.FechaSeguimientoAnalista = false;
        // this.disableValidation.AnalistaVarado = false;
        this.disableValidation.EstadoAnalistaVarado = false;
        this.disableValidation.FechaCompromiso = false;
        this.disableValidation.Bloqueante = false;
        this.disableValidation.FechaMetaCelula = false;
      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.LEGALIZACION) {
        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.FechaSeguimientoCoordinador = false;
        this.disableValidation.FechaAsignacion = false;
        this.disableValidation.AsignacionAnalista = false;

        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.FechaSeguimientoAnalista = false;
        this.disableValidation.AnalistaVarado = false;
        this.disableValidation.EstadoAnalistaVarado = false;
        this.disableValidation.Bloqueante = false;
        this.disableValidation.FechaMetaCelula = false;
      }

      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.PROMESA) {
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.ObservacionAnalista = false;
        // this.disableValidation.ObservacionCoordinador = false;
        // this.disableValidation.AsignacionAnalistaPromesas = false;
        // this.disableValidation.FechaMetaCelula = false;
      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.PROMESA) {
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.ObservacionAnalista = false;
        // this.disableValidation.EstadoCoordinador = false;
        // this.disableValidation.ObservacionCoordinador = false;
        // this.disableValidation.AsignacionAnalistaPromesas = false;
        // this.disableValidation.FechaMetaCelula = false;
      }

      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.SUBSIDIO) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.FechaEstadoAnalista = false;
        this.disableValidation.TipoInconsistencia = false;
        this.disableValidation.ComunicadosEnviados = false;
        this.disableValidation.FechaCompromiso = false;
        this.disableValidation.FechaMetaCelula = false;
        this.disableValidation.EstadoSubsidioMCY = false;
      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.SUBSIDIO) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.FechaEstadoCoordinador = false;
        this.disableValidation.TipoInconsistencia = false;
        this.disableValidation.ComunicadosEnviados = false;
        this.disableValidation.FechaMetaCelula = false;
        this.disableValidation.EstadoSubsidioMCY = false;
      }


      if ((role == 'Administrador' || role == 'Analista') && this.reportType == 4) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == 4) {
        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
      }

      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.ENTREGA) {
        this.disableValidation.FechadeEntrega = false;
        this.disableValidation.HoradeEntrega = false;
        this.disableValidation.CreacionCaso = false;
        this.disableValidation.Apoderado = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.Arquitecta = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.CaidaEntregas = false;
        this.disableValidation.AnalistaEntregas = false;
        this.disableValidation.FechaMetaCelula = false;
      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.ENTREGA) {
        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.CaidaEntregas = false;
        this.disableValidation.AnalistaEntregas = false;
        this.disableValidation.FechaMetaCelula = false;
      }

      if ((role == 'Administrador' || role == 'Analista' || role == 'Coordinador') && this.reportType == 6) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.Comentarios = false;
        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
      }

      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.RECAUDO) {
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.ObservacionAnalista = false;
        // this.disableValidation.FechaAcuerdoProximoPago = false;
        // this.disableValidation.MontoPactado = false;
        // this.disableValidation.LlamadaNo1 = false;
        // this.disableValidation.LlamadaNo2 = false;
        // this.disableValidation.Fenalco1erBarrido = false;
        // this.disableValidation.Fenalco2doBarrido = false;
        // this.disableValidation.LlamadaNo3 = false;
        // this.disableValidation.LlamadaNo4 = false;
        // this.disableValidation.LlamadaNo5 = false;
        // this.disableValidation.AnalistaRecaudo = false;
        // this.disableValidation.EstadoEscriturado = false;
        // this.disableValidation.TipificacionMesAnterior = false;
        // this.disableValidation.ObservacionCoordinador = false;
        // this.disableValidation.FechaEnvioSMS = false;
        // this.disableValidation.FechaNotificacionAlerta = false;
        // this.disableValidation.FechaCarta1 = false;
        // this.disableValidation.FechaCarta2 = false;
        // this.disableValidation.FechaCarta3 = false;
        // this.disableValidation.FechaMetaCelula = false;
        // this.disableValidation.Operacion = false;
        // this.disableValidation.LlamadaNo_1 = false;
        // this.disableValidation.LlamadaNo_2 = false;
        // this.disableValidation.LlamadaNo_3 = false;

      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.RECAUDO) {
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.EstadoCoordinador = false;
        // this.disableValidation.ObservacionCoordinador = false;
        // this.disableValidation.TipificacionMesAnterior = false;
        // this.disableValidation.FechaMetaCelula = false;
        // this.disableValidation.Operacion = false;
        // this.disableValidation.LlamadaNo_1 = false;
        // this.disableValidation.LlamadaNo_2 = false;
        // this.disableValidation.LlamadaNo_3 = false;
      }

      if ((role == 'Administrador' || role == 'Analista' || role == 'Coordinador' || role == 'Visualizador') && this.reportType == this.TRAZABILIDAD) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.TipificacionCorreccionesCtl = false;
        this.disableValidation.AnalistaTrazabilidad = false;
        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.FechaMetaCelula = false;
      }


      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.ORDENES) {
        this.disableValidation.AuxOrdenesEscrituracion = false;
        this.disableValidation.Frpl = false;
        this.disableValidation.QuienFirmaEsfp = false;
        this.disableValidation.EstadoEsfpFrpl = false;

        this.disableValidation.AuxOrdenesEscrituracion = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;

        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;

        this.disableValidation.EstadoAbogado = false;
        this.disableValidation.ObservacionAbogado = false
        this.disableValidation.PresentoCambio = false;
        this.disableValidation.CualFueElCambio = false;
        this.disableValidation.NoPredialNacional = false;
        this.disableValidation.NumeroId = false;
        this.disableValidation.IdMunicipio = false;
        this.disableValidation.RadicacionOrdenPagoPySPredial = false;
        this.disableValidation.FechaEstimadaDePyS = false;
        this.disableValidation.TipoPyS = false;
        this.disableValidation.MunicipioPyS = false;
        this.disableValidation.EstadoPyS = false;
        this.disableValidation.EstadoOrdenes = false;
        this.disableValidation.ObservacionAnalistaACargo = false;
        this.disableValidation.AnalistaACargoNotaria = false;
        this.disableValidation.FechaMetaCelula = false;

      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.ORDENES) {
        this.disableValidation.AuxOrdenesEscrituracion = false;
        this.disableValidation.Frpl = false;
        this.disableValidation.QuienFirmaEsfp = false;
        this.disableValidation.EstadoEsfpFrpl = false;

        this.disableValidation.AuxOrdenesEscrituracion = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;

        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;

        this.disableValidation.EstadoAbogado = false;
        this.disableValidation.ObservacionAbogado = false
        this.disableValidation.PresentoCambio = false;
        this.disableValidation.CualFueElCambio = false;
        this.disableValidation.NoPredialNacional = false;
        this.disableValidation.NumeroId = false;
        this.disableValidation.IdMunicipio = false;
        this.disableValidation.RadicacionOrdenPagoPySPredial = false;
        this.disableValidation.FechaEstimadaDePyS = false;
        this.disableValidation.TipoPyS = false;
        this.disableValidation.MunicipioPyS = false;
        this.disableValidation.EstadoPyS = false;
        this.disableValidation.EstadoOrdenes = false;
        this.disableValidation.ObservacionAnalistaACargo = false;
        this.disableValidation.AnalistaACargoNotaria = false;
        this.disableValidation.FechaMetaCelula = false;

      }


      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.RENOVACION) {
        // this.disableValidation.FechaSeguimientoAnalista = false;
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.ObservacionAnalista = false;
        // this.disableValidation.EstadoPoderAnalista = false;
        // this.disableValidation.TipoDeNovedad = false;
        // this.disableValidation.ObservacionCoordinador = false;
        // this.disableValidation.FechaSeguimientoBanco = false;
        // this.disableValidation.EstadoBanco = false;
        // this.disableValidation.ObservacionBanco = false;
        // this.disableValidation.FechaUltimaNotificacion = false;
        // this.disableValidation.FechaCompromiso = false;
        // this.disableValidation.NotificacionesNegocio = false;
        // this.disableValidation.FechaMetaCelula = false;


      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.RENOVACION) {
        // this.disableValidation.CampanasEspeciales = false;
        // this.disableValidation.EstadoPoderAnalista = false;
        // this.disableValidation.FechaSeguimientoCoordinador = false;
        // this.disableValidation.EstadoCoordinador = false;
        // this.disableValidation.ObservacionCoordinador = false;
        // this.disableValidation.TipoDeNovedad = false;
        // this.disableValidation.Analista_Outsourcing = false;
        // this.disableValidation.FechaAsignacion = false;
        // this.disableValidation.CausalRenovacion = false;
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.ObservacionAnalista = false;
        // this.disableValidation.FechaSeguimientoAnalista = false;
        // this.disableValidation.FechaSeguimientoBanco = false;
        // this.disableValidation.EstadoBanco = false;
        // this.disableValidation.ObservacionBanco = false;
        // this.disableValidation.FechaUltimaNotificacion = false;
        // this.disableValidation.FechaCompromiso = false;
        // this.disableValidation.NotificacionesNegocio = false;
        // this.disableValidation.FechaMetaCelula = false;
      }

      if ((role == 'Administrador' || role == 'Analista') && this.reportType == this.ESCRITURACION) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.FechaPredial = false;
        this.disableValidation.FechaEstampilla = false;
        this.disableValidation.FechaPoderFidubogota = false;
        this.disableValidation.RecorridoJuridico = false;
        this.disableValidation.ClienteExterior = false;
        this.disableValidation.FechaAsigna = false;
        this.disableValidation.FechaMetaComite = false;
        this.disableValidation.FechaMetaCelula = false;
        this.disableValidation.AnalistaEscrituracion = false;



      } else if ((role == 'Administrador' || role == 'Coordinador') && this.reportType == this.ESCRITURACION) {
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.CaidaEntregas = false;
        this.disableValidation.TubosDeGestion = false;
        this.disableValidation.EstadoPromesas = false;
        this.disableValidation.FechaPredial = false;
        this.disableValidation.FechaEstampilla = false;
        this.disableValidation.FechaPoderFidubogota = false;
        this.disableValidation.RecorridoJuridico = false;
        this.disableValidation.ClienteExterior = false;
        this.disableValidation.FechaAsigna = false;
        this.disableValidation.FechaMetaComite = false;
        this.disableValidation.FechaMetaCelula = false;
        this.disableValidation.AnalistaEscrituracion = false;


      }


      if ((role == 'Administrador' || role == 'Analista') && this.RIESGO) {
        // this.disableValidation.FechaSeguimientoAnalista2 = false;
        // this.disableValidation.FechaInicialSeguimientoAnalista = false;
        // this.disableValidation.FechaCompromisoAnalista = false;
        // this.disableValidation.CausalFamilia = false;
        // this.disableValidation.ObservacionesDeNegociosEnRiesgo = false;
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.CausalDeRiesgo = false;
        // this.disableValidation.CausalDeRiesgos2 = false;
        // this.disableValidation.CausalDeRiesgos3 = false;
        // this.disableValidation.CausalDeRiesgos4 = false;
        // this.disableValidation.EstrategiaDesistimiento = false;
        // this.disableValidation.NegocioMetaAnioActual = false;
        // this.disableValidation.EstadoDelEncargo = false;
        // this.disableValidation.NotificacionesCarta = false;
        // this.disableValidation.FechaMetaCelula = false;


      }

      if ((role == 'Administrador' || role == 'Coordinador') && this.RIESGO) {
        // this.disableValidation.FechaSubsanado = false;
        // this.disableValidation.EstadoCoordinador = false;
        // this.disableValidation.FechaSeguimientoAnalista2 = false;
        // this.disableValidation.FechaInicialSeguimientoAnalista = false;
        // this.disableValidation.PrioridadDelNegocio = false;
        // this.disableValidation.Fuente = false;
        // this.disableValidation.AnalistaNegociosEnRiesgo = false;
        // this.disableValidation.FechaCompromisoAnalista = false;
        // this.disableValidation.CausalFamilia = false;
        // this.disableValidation.ObservacionesDeNegociosEnRiesgo = false;
        // this.disableValidation.EstadoAnalista = false;
        // this.disableValidation.CausalManejoDeAuxiliar = false;
        // this.disableValidation.CausalDeRiesgo = false;
        // this.disableValidation.CausalDeRiesgos2 = false;
        // this.disableValidation.CausalDeRiesgos3 = false;
        // this.disableValidation.CausalDeRiesgos4 = false;
        // this.disableValidation.EstrategiaDesistimiento = false;
        // this.disableValidation.NegocioMetaAnioActual = false;
        // this.disableValidation.EstadoDelEncargo = false;
        // this.disableValidation.NotificacionesCarta = false;
        // this.disableValidation.FechaMetaCelula = false;
      }

      if ((role == 'Administrador' || role == 'Analista' || role == 'Coordinador') && this.RENEGOCIACION) {

        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.FechaGestion = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.TuboGestion = false;
        this.disableValidation.AnalistaAsignado = false;
        this.disableValidation.FechaAsignacion = false;
        this.disableValidation.Compromiso = false;
        this.disableValidation.FechaProxGestion = false;
        this.disableValidation.NegocioConCierreFinanciero = false;
        this.disableValidation.RecursosPropios = false;
        this.disableValidation.IngresoFamiliar = false;
        this.disableValidation.ClasificacionSisben = false;
        this.disableValidation.SimmularConMCY = false;
        this.disableValidation.AccionRecomendada = false;
        this.disableValidation.EstadoSubsidioMCY = false;
        this.disableValidation.ValorCreditoAcordado = false;
        this.disableValidation.ObservacionCampanaEnrolamientoSisben = false;
        this.disableValidation.AvanceObra = false;
        this.disableValidation.BonoEstrategiaCredito = false;
        this.disableValidation.ClienteNoAcepta = false;
        this.disableValidation.FechaInicioEstado = false;
        this.disableValidation.FechaAgenda = false;
        this.disableValidation.Agenda = false;
        this.disableValidation.SemaforoSatisfaccion = false;
        this.disableValidation.NumeroRadicadoEnrolamiento = false;
        this.disableValidation.FechaEnrolamiento = false;
        this.disableValidation.PostuladoMCY = false;
        this.disableValidation.FechaMetaCelula = false;


      }
      if ((role == 'Administrador' || role == 'Analista' || role == 'Coordinador') && this.DESISTIMIENTOS) {

        this.disableValidation.Indemnizacion = false;
        this.disableValidation.FormaDevolucion = false;
        this.disableValidation.Banco = false;
        this.disableValidation.NumeroCuenta = false;
        this.disableValidation.TipoCuenta = false;
        this.disableValidation.EntidadEncargadaDevolucion = false;
        this.disableValidation.EstadoDesistimiento = false;
        this.disableValidation.TipoDesistimiento = false;
        this.disableValidation.FechaEnvioCertificacionBancaria = false;
        this.disableValidation.FechaElaboracionMemorando = false;
        this.disableValidation.NumeroMemorando = false;
        this.disableValidation.EstadoFinal = false;
        this.disableValidation.Observaciones = false;
        this.disableValidation.NotaMemoFidudavivienda = false;
        this.disableValidation.Asistente = false;
        this.disableValidation.VoboAnalista = false;


      }

      if ((role == 'Administrador' || role == 'Analista' || role == 'Coordinador') && this.PAZYSALVOS) {

        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.NegocioFenalpagare = false;
        this.disableValidation.CasosAutorizacionEspecial = false;
        this.disableValidation.AjusteAplicacionPago = false;
        this.disableValidation.TipoSolicitud = false;
        this.disableValidation.ProcesoPendienteCartera = false;
        this.disableValidation.ResponsableCartera = false;
        this.disableValidation.ObservacionCartera = false;
        this.disableValidation.AplicacionBonoDescuento = false;
        this.disableValidation.CausalDevolucion = false;
        this.disableValidation.ObservacionesAnalistaTramites = false;
        this.disableValidation.DocumentoGenerado = false;
        this.disableValidation.ResponsableCarteraDos = false;
        this.disableValidation.ValorBonoDescuento = false;
        this.disableValidation.LiquidadorGastosEscrituracion = false;
        this.disableValidation.MotivoDevolucion = false;
        this.disableValidation.FechaSolicitud = false;
        this.disableValidation.FechaRevision = false;
        this.disableValidation.FechaObservacionAjustes = false;
        this.disableValidation.FechaEvacuadoPyS = false;
        this.disableValidation.FechaNotificacionObsTramites = false;
        this.disableValidation.FechaDevolucionTramites = false;


      }


      if ((role == 'Cartera' ) && this.PAZYSALVOS) {

        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;
        this.disableValidation.ProcesoPendienteCartera = false;
        this.disableValidation.ResponsableCartera = false;
        this.disableValidation.ObservacionCartera = false;
        this.disableValidation.AplicacionBonoDescuento = false;
        this.disableValidation.CausalDevolucion = false;
        this.disableValidation.ObservacionesAnalistaTramites = false;
        this.disableValidation.DocumentoGenerado = false;
        this.disableValidation.ResponsableCarteraDos = false;
        this.disableValidation.FechaRevision = false;
        this.disableValidation.FechaObservacionAjustes = false;
        this.disableValidation.FechaEvacuadoPyS = false;
        this.disableValidation.FechaNotificacionObsTramites = false;

      }

      if ((role == 'Administrador' || role == 'Analista' || role == 'Coordinador') && this.MACRO360) {

        this.disableValidation.EstadoCoordinador = false;
        this.disableValidation.ObservacionCoordinador = false;
        this.disableValidation.EstadoAnalista = false;
        this.disableValidation.ObservacionAnalista = false;


      }

      if ((role == 'Administrador' || role == 'Analista' || role == 'Coordinador') && this.INTERNACIONAL) {

        this.disableValidation.AsesorSeguimiento1 = false;
        this.disableValidation.AsesorSeguimiento2 = false;
        this.disableValidation.NotificacionCarta = false;
        this.disableValidation.ObservacionAsesor = false;
        this.disableValidation.EstadoRecaudo = false;
        this.disableValidation.EstadoCredito = false;
        this.disableValidation.EstadoPromesa = false;
        this.disableValidation.EstadoLegalizacion = false;
        this.disableValidation.EstadoEscrituracion = false;
        this.disableValidation.EstadoEntrega = false;
        this.disableValidation.EstadoPoderes = false;
        this.disableValidation.MotivoRiesgo = false;
      }


    }






    console.log('this.currentElement.FechaAcuerdoProximoPago', this.currentElement.FechaAcuerdoProximoPago);

    this.form = this.formBuilder.group(
      {
        ID_PA: [this.currentElement.ID_PA],
        EstadoCoordinador: [{ value: this.currentElement.EstadoCoordinador, disabled: this.disableValidation.EstadoCoordinador }],
        ObservacionCoordinador: [{ value: this.currentElement.ObservacionCoordinador, disabled: this.disableValidation.ObservacionCoordinador }, [Validators.maxLength(8000)]],

        EstadoAnalista: [{ value: this.ORDENES != this.reportType ? this.currentElement.EstadoAnalista : this.currentElement.EstadoAnalista, disabled: this.disableValidation.EstadoAnalista }],
        ObservacionAnalista: [{ value: this.ORDENES != this.reportType ? this.currentElement.ObservacionAnalista : this.currentElement.ObservacionAnalista, disabled: this.disableValidation.ObservacionAnalista }, [Validators.maxLength(8000)]],

        AsignacionAnalista: [{ value: this.currentElement.AsignacionAnalista, disabled: this.disableValidation.AsignacionAnalista }],
        AnalistaVarado: [{ value: this.currentElement.AnalistaVarado, disabled: this.disableValidation.AnalistaVarado }],
        FechaSeguimientoCoordinador: [{ value: this.currentElement.FechaSeguimientoCoordinador != null ? new Date(this.currentElement.FechaSeguimientoCoordinador) : null, disabled: this.disableValidation.FechaSeguimientoCoordinador }],
        FechaAsignacion: [{ value: this.currentElement.FechaAsignacion != null ? new Date(this.currentElement.FechaAsignacion) : null, disabled: this.disableValidation.FechaAsignacion }],
        FechaSeguimientoAnalista: [{ value: this.currentElement.FechaSeguimientoAnalista != null ? new Date(this.currentElement.FechaSeguimientoAnalista) : null, disabled: this.disableValidation.FechaSeguimientoAnalista }],
        EstadoAnalistaVarado: [{ value: this.currentElement.EstadoAnalistaVarado, disabled: this.disableValidation.EstadoAnalistaVarado }],


        FechadeEntrega: [{ value: this.currentElement.FechadeEntrega != null ? new Date(this.currentElement.FechadeEntrega) : null, disabled: this.disableValidation.FechadeEntrega }],
        HoradeEntrega: [{ value: this.currentElement.HoradeEntrega != null ? this.currentElement.HoradeEntrega : null, disabled: this.disableValidation.HoradeEntrega }],
        Arquitecta: [{ value: this.currentElement.Arquitecta != null ? this.currentElement.Arquitecta : null, disabled: this.disableValidation.Arquitecta }],
        CreacionCaso: [{ value: this.currentElement.CreacionCaso != null ? this.currentElement.CreacionCaso : null, disabled: this.disableValidation.CreacionCaso }],
        Apoderado: [{ value: this.currentElement.Apoderado != null ? this.currentElement.Apoderado : null, disabled: this.disableValidation.Apoderado }],

        Bloqueante: [{ value: this.currentElement.Bloqueante != null ? this.currentElement.Bloqueante : null, disabled: this.disableValidation.Bloqueante }],

        Comentarios: [{ value: this.currentElement.Comentarios != null ? this.currentElement.Comentarios : null, disabled: this.disableValidation.Comentarios }],

        TipificacionCorreccionesCtl: [{ value: this.currentElement.TipificacionCorreccionesCtl != null ? this.currentElement.TipificacionCorreccionesCtl : null, disabled: this.disableValidation.TipificacionCorreccionesCtl }],
        AnalistaTrazabilidad: [{ value: this.currentElement.AnalistaTrazabilidad != null ? this.currentElement.AnalistaTrazabilidad : null, disabled: this.disableValidation.AnalistaTrazabilidad }],

        TipoInconsistencia: [{ value: this.currentElement.TipoInconsistencia != null ? this.currentElement.TipoInconsistencia : null, disabled: this.disableValidation.TipoInconsistencia }],
        ComunicadosEnviados: [{ value: this.currentElement.ComunicadosEnviados != null ? this.currentElement.ComunicadosEnviados : null, disabled: this.disableValidation.ComunicadosEnviados }],

        AuxOrdenesEscrituracion: [{ value: this.currentElement.AuxOrdenesEscrituracion != null ? this.currentElement.AuxOrdenesEscrituracion : null, disabled: this.disableValidation.AuxOrdenesEscrituracion }],
        Frpl: [{ value: this.currentElement.Frpl != null ? this.currentElement.Frpl : null, disabled: this.disableValidation.Frpl }],
        QuienFirmaEsfp: [{ value: this.currentElement.QuienFirmaEsfp != null ? this.currentElement.QuienFirmaEsfp : null, disabled: this.disableValidation.QuienFirmaEsfp }],
        EstadoEsfpFrpl: [{ value: this.currentElement.EstadoEsfpFrpl != null ? this.currentElement.EstadoEsfpFrpl : null, disabled: this.disableValidation.EstadoEsfpFrpl }],
        EstadoAbogado: [{ value: this.currentElement.EstadoAbogado != null ? this.currentElement.EstadoAbogado : null, disabled: this.disableValidation.EstadoAbogado }],
        ObservacionAbogado: [{ value: this.currentElement.ObservacionAbogado != null ? this.currentElement.ObservacionAbogado : null, disabled: this.disableValidation.ObservacionAbogado }, [Validators.maxLength(8000)]],
        PresentoCambio: [{ value: this.currentElement.PresentoCambio != null ? this.currentElement.PresentoCambio : null, disabled: this.disableValidation.PresentoCambio }],
        CualFueElCambio: [{ value: this.currentElement.CualFueElCambio != null ? this.currentElement.CualFueElCambio : null, disabled: this.disableValidation.CualFueElCambio }],
        NoPredialNacional: [{ value: this.currentElement.NoPredialNacional != null ? this.currentElement.NoPredialNacional : null, disabled: this.disableValidation.NoPredialNacional }],
        NumeroId: [{ value: this.currentElement.NumeroId != null ? this.currentElement.NumeroId : null, disabled: this.disableValidation.NumeroId }],
        IdMunicipio: [{ value: this.currentElement.IdMunicipio != null ? this.currentElement.IdMunicipio : null, disabled: this.disableValidation.IdMunicipio }],
        RadicaciónOrdenPagoPySPredial: [{ value: this.currentElement.RadicaciónOrdenPagoPySPredial != null ? this.currentElement.RadicaciónOrdenPagoPySPredial : null, disabled: this.disableValidation.RadicacionOrdenPagoPySPredial }],
        FechaEstimadaDePyS: [{ value: this.currentElement.FechaEstimadaDePyS != null ? new Date(this.currentElement.FechaEstimadaDePyS) : null, disabled: this.disableValidation.FechaEstimadaDePyS }],
        TipoPyS: [{ value: this.currentElement.TipoPyS != null ? this.currentElement.TipoPyS : null, disabled: this.disableValidation.TipoPyS }],
        MunicipioPyS: [{ value: this.currentElement.MunicipioPyS != null ? this.currentElement.MunicipioPyS : null, disabled: this.disableValidation.MunicipioPyS }],
        EstadoPyS: [{ value: this.currentElement.EstadoPyS != null ? this.currentElement.EstadoPyS : null, disabled: this.disableValidation.EstadoPyS }],
        EstadoOrdenes: [{ value: this.currentElement.EstadoOrdenes != null ? this.currentElement.EstadoOrdenes : null, disabled: this.disableValidation.EstadoOrdenes }],
        ObservacionAnalistaACargo: [{ value: this.currentElement.ObservacionAnalistaACargo != null ? this.currentElement.ObservacionAnalistaACargo : null, disabled: this.disableValidation.ObservacionAnalistaACargo }],
        AnalistaACargoNotaria: [{ value: this.currentElement.AnalistaACargoNotaria != null ? this.currentElement.AnalistaACargoNotaria : null, disabled: this.disableValidation.AnalistaACargoNotaria }],


        CampanasEspeciales: [{ value: this.currentElement.CampanasEspeciales != null ? this.currentElement.CampanasEspeciales : null, disabled: this.disableValidation.CampanasEspeciales }],
        FechaSeguimientoBanco: [{ value: this.currentElement.FechaSeguimientoBanco != null ? new Date(this.currentElement.FechaSeguimientoBanco) : null, disabled: this.disableValidation.FechaSeguimientoBanco }],
        FechaUltimaNotificacion: [{ value: this.currentElement.FechaUltimaNotificacion != null ? new Date(this.currentElement.FechaUltimaNotificacion) : null, disabled: this.disableValidation.FechaUltimaNotificacion }],
        FechaCompromiso: [{ value: this.currentElement.FechaCompromiso != null ? new Date(this.currentElement.FechaCompromiso) : null, disabled: this.disableValidation.FechaCompromiso }],
        EstadoBanco: [{ value: this.currentElement.EstadoBanco != null ? this.currentElement.EstadoBanco : null, disabled: this.disableValidation.EstadoBanco }],
        ObservacionBanco: [{ value: this.currentElement.ObservacionBanco != null ? this.currentElement.ObservacionBanco : null, disabled: this.disableValidation.ObservacionBanco }],
        NotificacionesNegocio: [{ value: this.currentElement.NotificacionesNegocio != null ? this.currentElement.NotificacionesNegocio : null, disabled: this.disableValidation.NotificacionesNegocio }],
        CausalRenovacion: [{ value: this.currentElement.CausalRenovacion != null ? this.currentElement.CausalRenovacion : null, disabled: this.disableValidation.CausalRenovacion }],
        EstadoPoderAnalista: [{ value: this.currentElement.EstadoPoderAnalista != null ? this.currentElement.EstadoPoderAnalista : null, disabled: this.disableValidation.EstadoPoderAnalista }],
        TipoDeNovedad: [{ value: this.currentElement.TipoDeNovedad != null ? this.currentElement.TipoDeNovedad : null, disabled: this.disableValidation.TipoDeNovedad }],
        Analista_Outsourcing: [{ value: this.currentElement.Analista_Outsourcing != null ? this.currentElement.Analista_Outsourcing : null, disabled: this.disableValidation.Analista_Outsourcing }],
        AsignacionAnalistaPromesas: [{ value: this.currentElement.AsignacionAnalistaPromesas != null ? this.currentElement.AsignacionAnalistaPromesas : null, disabled: this.disableValidation.AsignacionAnalistaPromesas }],


        FechaAcuerdoProximoPago: [{ value: this.currentElement.FechaAcuerdoProximoPago != null ? new Date(this.currentElement.FechaAcuerdoProximoPago) : null, disabled: this.disableValidation.FechaAcuerdoProximoPago }],
        LlamadaNo1: [{ value: this.currentElement.LlamadaNo1 != null ? this.currentElement.LlamadaNo1 : null, disabled: this.disableValidation.LlamadaNo1 }],
        MontoPactado: [{ value: this.currentElement.MontoPactado != null ? this.currentElement.MontoPactado : null, disabled: this.disableValidation.MontoPactado }],
        LlamadaNo2: [{ value: this.currentElement.LlamadaNo2 != null ? this.currentElement.LlamadaNo2 : null, disabled: this.disableValidation.LlamadaNo2 }],
        Fenalco1erBarrido: [{ value: this.currentElement.Fenalco1erBarrido != null ? this.currentElement.Fenalco1erBarrido : null, disabled: this.disableValidation.Fenalco1erBarrido }],
        Fenalco2doBarrido: [{ value: this.currentElement.Fenalco2doBarrido != null ? this.currentElement.Fenalco2doBarrido : null, disabled: this.disableValidation.Fenalco2doBarrido }],
        LlamadaNo3: [{ value: this.currentElement.LlamadaNo3 != null ? this.currentElement.LlamadaNo3 : null, disabled: this.disableValidation.LlamadaNo3 }],
        LlamadaNo4: [{ value: this.currentElement.LlamadaNo4 != null ? this.currentElement.LlamadaNo4 : null, disabled: this.disableValidation.LlamadaNo4 }],
        LlamadaNo5: [{ value: this.currentElement.LlamadaNo5 != null ? this.currentElement.LlamadaNo5 : null, disabled: this.disableValidation.LlamadaNo5 }],
        AnalistaRecaudo: [{ value: this.currentElement.AnalistaRecaudo != null ? this.currentElement.AnalistaRecaudo : null, disabled: this.disableValidation.AnalistaRecaudo }],
        FechaEnvioSMS: [{ value: this.currentElement.FechaEnvioSMS != null ? new Date(this.currentElement.FechaEnvioSMS ) : null, disabled: this.disableValidation.FechaEnvioSMS  }],
        FechaNotificacionAlerta: [{ value: this.currentElement.FechaNotificacionAlerta != null ? new Date(this.currentElement.FechaNotificacionAlerta ) : null, disabled: this.disableValidation.FechaNotificacionAlerta  }],
        FechaCarta1: [{ value: this.currentElement.FechaCarta1 != null ? new Date(this.currentElement.FechaCarta1 ) : null, disabled: this.disableValidation.FechaCarta1  }],
        FechaCarta2: [{ value: this.currentElement.FechaCarta2 != null ? new Date(this.currentElement.FechaCarta2 ) : null, disabled: this.disableValidation.FechaCarta2  }],
        FechaCarta3: [{ value: this.currentElement.FechaCarta3 != null ? new Date(this.currentElement.FechaCarta3 ) : null, disabled: this.disableValidation.FechaCarta3  }],
        LlamadaNo_1: [{ value: this.currentElement.LlamadaNo_1 != null ? new Date(this.currentElement.LlamadaNo_1) : null, disabled: this.disableValidation.LlamadaNo_1 }],
        LlamadaNo_2: [{ value: this.currentElement.LlamadaNo_2 != null ? new Date(this.currentElement.LlamadaNo_2) : null, disabled: this.disableValidation.LlamadaNo_2 }],
        LlamadaNo_3: [{ value: this.currentElement.LlamadaNo_3 != null ? new Date(this.currentElement.LlamadaNo_3) : null, disabled: this.disableValidation.LlamadaNo_3 }],

        EstadoEscriturado: [{ value: this.currentElement.EstadoEscriturado != null ? this.currentElement.EstadoEscriturado : null, disabled: this.disableValidation.EstadoEscriturado }],
        TipificacionMesAnterior: [{ value: this.currentElement.TipificacionMesAnterior != null ? this.currentElement.TipificacionMesAnterior : null, disabled: this.disableValidation.TipificacionMesAnterior }],
        Operacion: [{ value: this.currentElement.Operacion != null ? this.currentElement.Operacion : null, disabled: this.disableValidation.Operacion }],

        ID: [this.currentElement.ID],


        FechaSubsanado: [{ value: this.currentElement.FechaSubsanado != null ? new Date(this.currentElement.FechaSubsanado ) : null, disabled: this.disableValidation.FechaSubsanado  }],
        FechaSeguimientoAnalista2: [{ value: this.currentElement.FechaSeguimientoAnalista2 != null ? new Date(this.currentElement.FechaSeguimientoAnalista2 ) : null, disabled: this.disableValidation.FechaSeguimientoAnalista2  }],
        FechaInicialSeguimientoAnalista: [{ value: this.currentElement.FechaInicialSeguimientoAnalista != null ? new Date(this.currentElement.FechaInicialSeguimientoAnalista ) : null, disabled: this.disableValidation.FechaInicialSeguimientoAnalista  }],
        PrioridadDelNegocio: [{ value: this.currentElement.PrioridadDelNegocio != null ? this.currentElement.PrioridadDelNegocio : null, disabled: this.disableValidation.PrioridadDelNegocio }],
        MesDeGestion: [{ value: this.currentElement.MesDeGestion != null ? this.currentElement.MesDeGestion : null, disabled: this.disableValidation.MesDeGestion }],
        ResponsableQueReporta: [{ value: this.currentElement.ResponsableQueReporta != null ? this.currentElement.ResponsableQueReporta : null, disabled: this.disableValidation.ResponsableQueReporta }],
        NotificacionesCarta: [{ value: this.currentElement.NotificacionesCarta != null ? this.currentElement.NotificacionesCarta : null, disabled: this.disableValidation.NotificacionesCarta }],
        Fuente: [{ value: this.currentElement.Fuente != null ? this.currentElement.Fuente : null, disabled: this.disableValidation.Fuente }],
        AnalistaNegociosEnRiesgo: [{ value: this.currentElement.AnalistaNegociosEnRiesgo != null ? this.currentElement.AnalistaNegociosEnRiesgo : null, disabled: this.disableValidation.AnalistaNegociosEnRiesgo }],
        FechaCompromisoAnalista: [{ value: this.currentElement.FechaCompromisoAnalista != null ? new Date(this.currentElement.FechaCompromisoAnalista ) : null, disabled: this.disableValidation.FechaCompromisoAnalista  }],
        DocumentoFirmado: [{ value: this.currentElement.DocumentoFirmado != null ? this.currentElement.DocumentoFirmado : null, disabled: this.disableValidation.DocumentoFirmado }],
        EstadoDelEncargo: [{ value: this.currentElement.EstadoDelEncargo != null ? this.currentElement.EstadoDelEncargo : null, disabled: this.disableValidation.EstadoDelEncargo }],
        TipoDeClausulaSiAplicaParaEncargo: [{ value: this.currentElement.TipoDeClausulaSiAplicaParaEncargo != null ? this.currentElement.TipoDeClausulaSiAplicaParaEncargo : null, disabled: this.disableValidation.TipoDeClausulaSiAplicaParaEncargo }],
        CausalFamilia: [{ value: this.currentElement.CausalFamilia != null ? this.currentElement.CausalFamilia : null, disabled: this.disableValidation.CausalFamilia }],
        SubsanadoAl100: [{ value: this.currentElement.SubsanadoAl100 != null ? this.currentElement.SubsanadoAl100 : null, disabled: this.disableValidation.SubsanadoAl100 }],
        Soportes: [{ value: this.currentElement.Soportes != null ? this.currentElement.Soportes : null, disabled: this.disableValidation.Soportes }],
        ObservacionesDeNegociosEnRiesgo: [{ value: this.currentElement.ObservacionesDeNegociosEnRiesgo != null ? this.currentElement.ObservacionesDeNegociosEnRiesgo : null, disabled: this.disableValidation.ObservacionesDeNegociosEnRiesgo }],
        BancoDeCreditoNegado: [{ value: this.currentElement.BancoDeCreditoNegado != null ? this.currentElement.BancoDeCreditoNegado : null, disabled: this.disableValidation.BancoDeCreditoNegado }],
        NuevaSolicitudEnOtroBanco: [{ value: this.currentElement.NuevaSolicitudEnOtroBanco != null ? this.currentElement.NuevaSolicitudEnOtroBanco : null, disabled: this.disableValidation.NuevaSolicitudEnOtroBanco }],
        NombreDelBanco: [{ value: this.currentElement.NombreDelBanco != null ? this.currentElement.NombreDelBanco : null, disabled: this.disableValidation.NombreDelBanco }],
        ValorDeSancion: [{ value: this.currentElement.ValorDeSancion != null ? this.currentElement.ValorDeSancion : null, disabled: this.disableValidation.ValorDeSancion }],
        EstadoParaDesistir: [{ value: this.currentElement.EstadoParaDesistir != null ? this.currentElement.EstadoParaDesistir : null, disabled: this.disableValidation.EstadoParaDesistir }],
        AsesorDelBanco: [{ value: this.currentElement.AsesorDelBanco != null ? this.currentElement.AsesorDelBanco : null, disabled: this.disableValidation.AsesorDelBanco }],
        CausalManejoDeAuxiliar: [{ value: this.currentElement.CausalManejoDeAuxiliar != null ? this.currentElement.CausalManejoDeAuxiliar : null, disabled: this.disableValidation.CausalManejoDeAuxiliar }],
        TiempoRespuesta: [{ value: this.currentElement.TiempoRespuesta != null ? this.currentElement.TiempoRespuesta : null, disabled: this.disableValidation.TiempoRespuesta }],
        CreditoAprobado: [{ value: this.currentElement.CreditoAprobado != null ? this.currentElement.CreditoAprobado : null, disabled: this.disableValidation.CreditoAprobado }],
        CausalDeRiesgo: [{ value: this.currentElement.CausalDeRiesgo != null ? this.currentElement.CausalDeRiesgo : null, disabled: this.disableValidation.CausalDeRiesgo }],
        CausalDeRiesgos2: [{ value: this.currentElement.CausalDeRiesgos2 != null ? this.currentElement.CausalDeRiesgos2 : null, disabled: this.disableValidation.CausalDeRiesgos2 }],
        CausalDeRiesgos3: [{ value: this.currentElement.CausalDeRiesgos3 != null ? this.currentElement.CausalDeRiesgos3 : null, disabled: this.disableValidation.CausalDeRiesgos3 }],
        CausalDeRiesgos4: [{ value: this.currentElement.CausalDeRiesgos4 != null ? this.currentElement.CausalDeRiesgos4 : null, disabled: this.disableValidation.CausalDeRiesgos4 }],
        EstrategiaDesistimiento: [{ value: this.currentElement.EstrategiaDesistimiento != null ? this.currentElement.EstrategiaDesistimiento : null, disabled: this.disableValidation.EstrategiaDesistimiento }],
        NegocioMetaAnioActual: [{ value: this.currentElement.NegocioMetaAnioActual != null ? this.currentElement.NegocioMetaAnioActual : null, disabled: this.disableValidation.NegocioMetaAnioActual }],

        CaidaEntregas: [{ value: this.currentElement.CaidaEntregas != null ? this.currentElement.CaidaEntregas : null, disabled: this.disableValidation.CaidaEntregas }],
        AnalistaEntregas: [{ value: this.currentElement.AnalistaEntregas != null ? this.currentElement.AnalistaEntregas : null, disabled: this.disableValidation.AnalistaEntregas }],
        TubosDeGestion: [{ value: this.currentElement.TubosDeGestion != null ? this.currentElement.TubosDeGestion : null, disabled: this.disableValidation.TubosDeGestion }],
        EstadoPromesas: [{ value: this.currentElement.EstadoPromesas != null ? this.currentElement.EstadoPromesas : null, disabled: this.disableValidation.EstadoPromesas }],
        FechaPredial: [{ value: this.currentElement.FechaPredial != null ? this.currentElement.FechaPredial : null, disabled: this.disableValidation.FechaPredial }],
        FechaEstampilla: [{ value: this.currentElement.FechaEstampilla != null ? this.currentElement.FechaEstampilla : null, disabled: this.disableValidation.FechaEstampilla }],
        FechaPoderFidubogota: [{ value: this.currentElement.FechaPoderFidubogota != null ? this.currentElement.FechaPoderFidubogota : null, disabled: this.disableValidation.FechaPoderFidubogota }],
        RecorridoJuridico: [{ value: this.currentElement.RecorridoJuridico != null ? this.currentElement.RecorridoJuridico : null, disabled: this.disableValidation.RecorridoJuridico }],
        ClienteExterior: [{ value: this.currentElement.ClienteExterior != null ? this.currentElement.ClienteExterior : null, disabled: this.disableValidation.ClienteExterior }],
        FechaAsigna: [{ value: this.currentElement.FechaAsigna != null ? this.currentElement.FechaAsigna : null, disabled: this.disableValidation.FechaAsigna }],
        FechaMetaComite: [{ value: this.currentElement.FechaMetaComite != null ? this.currentElement.FechaMetaComite : null, disabled: this.disableValidation.FechaMetaComite }],
        FechaMetaCelula: [{ value: this.currentElement.FechaMetaCelula != null ? this.currentElement.FechaMetaCelula : null, disabled: this.disableValidation.FechaMetaCelula }],
        AnalistaEscrituracion: [{ value: this.currentElement.AnalistaEscrituracion != null ? this.currentElement.AnalistaEscrituracion : null, disabled: this.disableValidation.AnalistaEscrituracion }],




        FechaEstadoCoordinador: [{ value: this.currentElement.FechaEstadoCoordinador != null ? new Date(this.currentElement.FechaEstadoCoordinador) : null, disabled: this.disableValidation.FechaEstadoCoordinador }],
        FechaEstadoAnalista: [{ value: this.currentElement.FechaEstadoAnalista != null ? new Date(this.currentElement.FechaEstadoAnalista) : null, disabled: this.disableValidation.FechaEstadoAnalista }],

        FechaGestion: [{ value: this.currentElement.FechaGestion != null ? new Date(this.currentElement.FechaGestion) : null, disabled: this.disableValidation.FechaGestion }],
        FechaProxGestion: [{ value: this.currentElement.FechaProxGestion != null ? new Date(this.currentElement.FechaProxGestion) : null, disabled: this.disableValidation.FechaProxGestion }],
        TuboGestion: [{ value: this.currentElement.TuboGestion != null ? this.currentElement.TuboGestion : null, disabled: this.disableValidation.TuboGestion }],
        AnalistaAsignado: [{ value: this.currentElement.AnalistaAsignado != null ? this.currentElement.AnalistaAsignado : null, disabled: this.disableValidation.AnalistaAsignado }],
        Compromiso: [{ value: this.currentElement.Compromiso != null ? this.currentElement.Compromiso : null, disabled: this.disableValidation.Compromiso }],
        NegocioConCierreFinanciero: [{ value: this.currentElement.NegocioConCierreFinanciero != null ? this.currentElement.NegocioConCierreFinanciero : null, disabled: this.disableValidation.NegocioConCierreFinanciero }],
        RecursosPropios: [{ value: this.currentElement.RecursosPropios != null ? this.currentElement.RecursosPropios : null, disabled: this.disableValidation.RecursosPropios }],
        IngresoFamiliar: [{ value: this.currentElement.IngresoFamiliar != null ? this.currentElement.IngresoFamiliar : null, disabled: this.disableValidation.IngresoFamiliar }],
        ClasificacionSisben: [{ value: this.currentElement.ClasificacionSisben != null ? this.currentElement.ClasificacionSisben : null, disabled: this.disableValidation.ClasificacionSisben }],
        SimmularConMCY: [{ value: this.currentElement.SimmularConMCY != null ? this.currentElement.SimmularConMCY : null, disabled: this.disableValidation.SimmularConMCY }],
        AccionRecomendada: [{ value: this.currentElement.AccionRecomendada != null ? this.currentElement.AccionRecomendada : null, disabled: this.disableValidation.AccionRecomendada }],
        EstadoSubsidioMCY:    [{ value: this.currentElement.EstadoSubsidioMCY != null ? this.currentElement.EstadoSubsidioMCY : null, disabled: this.disableValidation.EstadoSubsidioMCY }],
        ValorCreditoAcordado: [{ value: this.currentElement.ValorCreditoAcordado != null ? this.currentElement.ValorCreditoAcordado : null, disabled: this.disableValidation.ValorCreditoAcordado }],
        ObservacionCampanaEnrolamientoSisben: [{ value: this.currentElement.ObservacionCampanaEnrolamientoSisben != null ? this.currentElement.ObservacionCampanaEnrolamientoSisben : null, disabled: this.disableValidation.ObservacionCampanaEnrolamientoSisben }],
        AvanceObra: [{ value: this.currentElement.AvanceObra != null ? new Date(this.currentElement.AvanceObra) : null, disabled: this.disableValidation.AvanceObra }],
        BonoEstrategiaCredito: [{ value: this.currentElement.BonoEstrategiaCredito != null ? this.currentElement.BonoEstrategiaCredito : null, disabled: this.disableValidation.BonoEstrategiaCredito }],
        ClienteNoAcepta: [{ value: this.currentElement.ClienteNoAcepta != null ? this.currentElement.ClienteNoAcepta : null, disabled: this.disableValidation.ClienteNoAcepta }],
        FechaInicioEstado: [{ value: this.currentElement.FechaInicioEstado != null ? new Date(this.currentElement.FechaInicioEstado) : null, disabled: this.disableValidation.FechaInicioEstado }],
        FechaAgenda: [{ value: this.currentElement.FechaAgenda != null ? new Date(this.currentElement.FechaAgenda) : null, disabled: this.disableValidation.FechaAgenda }],
        Agenda: [{ value: this.currentElement.Agenda != null ? this.currentElement.Agenda : null, disabled: this.disableValidation.Agenda }],
        SemaforoSatisfaccion: [{ value: this.currentElement.SemaforoSatisfaccion != null ? this.currentElement.SemaforoSatisfaccion : null, disabled: this.disableValidation.SemaforoSatisfaccion }],
        NumeroRadicadoEnrolamiento: [{ value: this.currentElement.NumeroRadicadoEnrolamiento != null ? this.currentElement.NumeroRadicadoEnrolamiento : null, disabled: this.disableValidation.NumeroRadicadoEnrolamiento }],
        FechaEnrolamiento: [{ value: this.currentElement.FechaEnrolamiento != null ? this.currentElement.FechaEnrolamiento : null, disabled: this.disableValidation.FechaEnrolamiento }],
        PostuladoMCY: [{ value: this.currentElement.PostuladoMCY != null ? this.currentElement.PostuladoMCY : null, disabled: this.disableValidation.PostuladoMCY }],


        Indemnizacion: [{ value: this.currentElement.Indemnizacion != null ? this.currentElement.Indemnizacion : null, disabled: this.disableValidation.Indemnizacion }],
        FormaDevolucion: [{ value: this.currentElement.FormaDevolucion != null ? this.currentElement.FormaDevolucion : null, disabled: this.disableValidation.FormaDevolucion }],
        Banco: [{ value: this.currentElement.Banco != null ? this.currentElement.Banco : null, disabled: this.disableValidation.Banco }],
        NumeroCuenta: [{ value: this.currentElement.NumeroCuenta != null ? this.currentElement.NumeroCuenta : null, disabled: this.disableValidation.NumeroCuenta }],
        TipoCuenta: [{ value: this.currentElement.TipoCuenta != null ? this.currentElement.TipoCuenta : null, disabled: this.disableValidation.TipoCuenta }],
        EntidadEncargadaDevolucion: [{ value: this.currentElement.EntidadEncargadaDevolucion != null ? this.currentElement.EntidadEncargadaDevolucion : null, disabled: this.disableValidation.EntidadEncargadaDevolucion }],
        EstadoDesistimiento: [{ value: this.currentElement.EstadoDesistimiento != null ? this.currentElement.EstadoDesistimiento : null, disabled: this.disableValidation.EstadoDesistimiento }],
        TipoDesistimiento: [{ value: this.currentElement.TipoDesistimiento != null ? this.currentElement.TipoDesistimiento : null, disabled: this.disableValidation.TipoDesistimiento }],
        FechaEnvioCertificacionBancaria: [{ value: this.currentElement.FechaEnvioCertificacionBancaria != null ? new Date(this.currentElement.FechaEnvioCertificacionBancaria) : null, disabled: this.disableValidation.FechaEnvioCertificacionBancaria }],
        FechaElaboracionMemorando: [{ value: this.currentElement.FechaElaboracionMemorando != null ? new Date(this.currentElement.FechaElaboracionMemorando) : null, disabled: this.disableValidation.FechaElaboracionMemorando }],
        NumeroMemorando: [{ value: this.currentElement.NumeroMemorando != null ? this.currentElement.NumeroMemorando : null, disabled: this.disableValidation.NumeroMemorando }],
        EstadoFinal: [{ value: this.currentElement.EstadoFinal != null ? this.currentElement.EstadoFinal : null, disabled: this.disableValidation.EstadoFinal }],
        Observaciones: [{ value: this.currentElement.Observaciones != null ? this.currentElement.Observaciones : null, disabled: this.disableValidation.Observaciones }],
        NotaMemoFidudavivienda: [{ value: this.currentElement.NotaMemoFidudavivienda != null ? this.currentElement.NotaMemoFidudavivienda : null, disabled: this.disableValidation.NotaMemoFidudavivienda }],
        Asistente: [{ value: this.currentElement.Asistente != null ? this.currentElement.Asistente : null, disabled: this.disableValidation.Asistente }],
        VoboAnalista: [{ value: this.currentElement.VoboAnalista != null ? this.currentElement.VoboAnalista : null, disabled: this.disableValidation.VoboAnalista }],
        NegocioFenalpagare: [{ value: this.currentElement.NegocioFenalpagare != null ? this.currentElement.NegocioFenalpagare : null, disabled: this.disableValidation.NegocioFenalpagare }],
        CasosAutorizacionEspecial: [{ value: this.currentElement.CasosAutorizacionEspecial != null ? this.currentElement.CasosAutorizacionEspecial : null, disabled: this.disableValidation.CasosAutorizacionEspecial }],
        AjusteAplicacionPago: [{ value: this.currentElement.AjusteAplicacionPago != null ? this.currentElement.AjusteAplicacionPago : null, disabled: this.disableValidation.AjusteAplicacionPago }],
        TipoSolicitud: [{ value: this.currentElement.TipoSolicitud != null ? this.currentElement.TipoSolicitud : null, disabled: this.disableValidation.TipoSolicitud }],
        ProcesoPendienteCartera: [{ value: this.currentElement.ProcesoPendienteCartera != null ? this.currentElement.ProcesoPendienteCartera : null, disabled: this.disableValidation.ProcesoPendienteCartera }],
        ResponsableCartera: [{ value: this.currentElement.ResponsableCartera != null ? this.currentElement.ResponsableCartera : null, disabled: this.disableValidation.ResponsableCartera }],
        ObservacionCartera: [{ value: this.currentElement.ObservacionCartera != null ? this.currentElement.ObservacionCartera : null, disabled: this.disableValidation.ObservacionCartera }],
        AplicacionBonoDescuento: [{ value: this.currentElement.AplicacionBonoDescuento != null ? this.currentElement.AplicacionBonoDescuento : null, disabled: this.disableValidation.AplicacionBonoDescuento }],
        CausalDevolucion: [{ value: this.currentElement.CausalDevolucion != null ? this.currentElement.CausalDevolucion : null, disabled: this.disableValidation.CausalDevolucion }],
        ObservacionesAnalistaTramites: [{ value: this.currentElement.ObservacionesAnalistaTramites != null ? this.currentElement.ObservacionesAnalistaTramites : null, disabled: this.disableValidation.ObservacionesAnalistaTramites }],
        DocumentoGenerado: [{ value: this.currentElement.DocumentoGenerado != null ? this.currentElement.DocumentoGenerado : null, disabled: this.disableValidation.DocumentoGenerado }],
        ResponsableCarteraDos: [{ value: this.currentElement.ResponsableCarteraDos != null ? this.currentElement.ResponsableCarteraDos : null, disabled: this.disableValidation.ResponsableCarteraDos }],
        ValorBonoDescuento: [{ value: this.currentElement.ValorBonoDescuento != null ? this.currentElement.ValorBonoDescuento : null, disabled: this.disableValidation.ValorBonoDescuento }],
        LiquidadorGastosEscrituracion: [{ value: this.currentElement.LiquidadorGastosEscrituracion != null ? this.currentElement.LiquidadorGastosEscrituracion : null, disabled: this.disableValidation.LiquidadorGastosEscrituracion }],
        MotivoDevolucion: [{ value: this.currentElement.MotivoDevolucion != null ? this.currentElement.MotivoDevolucion : null, disabled: this.disableValidation.MotivoDevolucion }],
        FechaSolicitud: [{ value: this.currentElement.FechaSolicitud != null ? this.currentElement.FechaSolicitud : null, disabled: this.disableValidation.FechaSolicitud }],
        FechaRevision: [{ value: this.currentElement.FechaRevision != null ? this.currentElement.FechaRevision : null, disabled: this.disableValidation.FechaRevision }],
        FechaObservacionAjustes: [{ value: this.currentElement.FechaObservacionAjustes != null ? this.currentElement.FechaObservacionAjustes : null, disabled: this.disableValidation.FechaObservacionAjustes }],
        FechaEvacuadoPyS: [{ value: this.currentElement.FechaEvacuadoPyS != null ? this.currentElement.FechaEvacuadoPyS : null, disabled: this.disableValidation.FechaEvacuadoPyS }],
        FechaNotificacionObsTramites: [{ value: this.currentElement.FechaNotificacionObsTramites != null ? this.currentElement.FechaNotificacionObsTramites : null, disabled: this.disableValidation.FechaNotificacionObsTramites }],
        FechaDevolucionTramites: [{ value: this.currentElement.FechaDevolucionTramites != null ? this.currentElement.FechaDevolucionTramites : null, disabled: this.disableValidation.FechaDevolucionTramites }],

        AsesorSeguimiento1: [{ value: this.currentElement.AsesorSeguimiento1 != null ? new Date(this.currentElement.AsesorSeguimiento1) : null, disabled: this.disableValidation.AsesorSeguimiento1 }],
        AsesorSeguimiento2: [{ value: this.currentElement.AsesorSeguimiento2 != null ? new Date(this.currentElement.AsesorSeguimiento2) : null, disabled: this.disableValidation.AsesorSeguimiento2 }],
        NotificacionCarta: [{ value: this.currentElement.NotificacionCarta != null ? this.currentElement.NotificacionCarta : null, disabled: this.disableValidation.NotificacionCarta }],
        ObservacionAsesor: [{ value: this.currentElement.ObservacionAsesor != null ? this.currentElement.ObservacionAsesor : null, disabled: this.disableValidation.ObservacionAsesor }],
        EstadoRecaudo: [{ value: this.currentElement.EstadoRecaudo != null ? this.currentElement.EstadoRecaudo : null, disabled: this.disableValidation.EstadoRecaudo }],
        EstadoCredito: [{ value: this.currentElement.EstadoCredito != null ? this.currentElement.EstadoCredito : null, disabled: this.disableValidation.EstadoCredito }],
        EstadoPromesa: [{ value: this.currentElement.EstadoPromesa != null ? this.currentElement.EstadoPromesa : null, disabled: this.disableValidation.EstadoPromesa }],
        EstadoLegalizacion: [{ value: this.currentElement.EstadoLegalizacion != null ? this.currentElement.EstadoLegalizacion : null, disabled: this.disableValidation.EstadoLegalizacion }],
        EstadoEscrituracion: [{ value: this.currentElement.EstadoEscrituracion != null ? this.currentElement.EstadoEscrituracion : null, disabled: this.disableValidation.EstadoEscrituracion }],
        EstadoEntrega: [{ value: this.currentElement.EstadoEntrega != null ? this.currentElement.EstadoEntrega : null, disabled: this.disableValidation.EstadoEntrega }],
        EstadoPoderes: [{ value: this.currentElement.EstadoPoderes != null ? this.currentElement.EstadoPoderes : null, disabled: this.disableValidation.EstadoPoderes }],
        MotivoRiesgo: [{ value: this.currentElement.MotivoRiesgo != null ? this.currentElement.MotivoRiesgo : null, disabled: this.disableValidation.MotivoRiesgo }],


      }
    );

    Object.keys(this.form.controls).forEach(key => {
      console.log('key', key);
      this.beforeList[key] = this.form.controls[key].value;
    });


    console.log('this.beforeList', this.form.controls);

  }


  // getHeaderOptionsTable(dataGroup: string, opt: any) {
  //   // this.displayLoading = true;
  //   this.legalizacionService.getHeaderOptionsTable(this.obrasSelect, dataGroup)
  //     .subscribe(
  //       (data: any) => {
  //         console.log(data);

  //         data = data.map((sweetItem: String) => {
  //           if (sweetItem == null) {
  //             sweetItem = "Vacio";
  //           }
  //           return sweetItem;
  //         })

  //         if (opt == 0) {
  //           this.estadoCoordinadorList = data;
  //         } else if (opt == 1) {
  //           this.estadoAnalistaList = data;
  //         } else if (opt == 2) {
  //           this.asignacionAnalistaList = data;
  //         }


  //         // this.displayLoading = false;
  //       }, (err: any) => {
  //         console.log(err);
  //         // this.displayLoading = false;
  //       }
  //     )
  // }

  closeModal() {
    this.dialogRef.close();
  }

  saveData() {

    console.log(this.form.controls);

    let insertDate: String = '';
    if (this.reportType == this.LEGALIZACION) {
      let fechaFormatStr = 'null';
      if (this.form.controls['FechaSeguimientoCoordinador'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaSeguimientoCoordinador'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaSeguimientoAnalista'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaSeguimientoAnalista'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaAsignacion'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaAsignacion'].value);
        fechaFormatStr3 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['FechaCompromiso'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaCompromiso'].value);
        fechaFormatStr4 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }


      let fechaFormatStr5 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr5 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }


      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[FechaSeguimientoCoordinador],[EstadoCoordinador],[ObservacionCoordinador],[FechaSeguimientoAnalista],[EstadoAnalista],
        [ObservacionAnalista],[FechaAsignacion],[AsignacionAnalista],[AnalistaVarado],[EstadoAnalistaVarado],[FechaCompromiso],[Bloqueante],[FechaMetaCelula] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${fechaFormatStr2}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${fechaFormatStr3}'',
        ''${this.form.controls['AsignacionAnalista'].value}'',
        ''${this.form.controls['AnalistaVarado'].value}'',
        ''${this.form.controls['EstadoAnalistaVarado'].value}'',
        ''${fechaFormatStr4}'',
        ''${this.form.controls['Bloqueante'].value}'',
        ''${fechaFormatStr5}'')`;

    } else if (this.reportType == this.PROMESA) {
      let fechaFormatStr = 'null';
      if (this.form.controls['ObservacionCoordinador'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['ObservacionCoordinador'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }


      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista],[AsignacionAnalistaPromesas],[FechaMetaCelula] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${this.form.controls['AsignacionAnalistaPromesas'].value}'',
        ''${fechaFormatStr2}'')`;
    } else if (this.reportType == this.SUBSIDIO) {
      let fechaFormatStr = 'null';
      if (this.form.controls['FechaEstadoCoordinador'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaEstadoCoordinador'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaEstadoAnalista'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaEstadoAnalista'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaCompromiso'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaCompromiso'].value);
        fechaFormatStr3 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr4 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista],[FechaEstadoCoordinador],[FechaEstadoAnalista],[TipoInconsistencia],[ComunicadosEnviados],[FechaCompromiso],[FechaMetaCelula],[EstadoSubsidioMCY] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${fechaFormatStr}'',
        ''${fechaFormatStr2}'',
        ''${this.form.controls['TipoInconsistencia'].value}'',
        ''${this.form.controls['ComunicadosEnviados'].value}'',
        ''${fechaFormatStr3}'',
        ''${fechaFormatStr4}'',
        ''${this.form.controls['EstadoSubsidioMCY'].value}'')`;
    } else if (this.reportType == 4) {
      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'')`;
    } else if (this.reportType == this.ENTREGA) {
      console.log(`this.form.controls['FechadeEntrega'].value`, this.form.controls['FechadeEntrega'].value);

      let fechaFormatStr = 'null';
      if (this.form.controls['FechadeEntrega'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechadeEntrega'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['ObservacionCoordinador'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['ObservacionCoordinador'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr3 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[FechadeEntrega],[HoradeEntrega],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista],[Arquitecta],[CaidaEntregas],[AnalistaEntregas],[FechaMetaCelula] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['HoradeEntrega'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${fechaFormatStr2}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${this.form.controls['Arquitecta'].value}'',
        ''${this.form.controls['CaidaEntregas'].value}'',
        ''${this.form.controls['AnalistaEntregas'].value}'',
        ''${fechaFormatStr3}'')`;
    } else if (this.reportType == 6) {
      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[Comentarios],[EstadoAnalista],[ObservacionAnalista] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${this.form.controls['Comentarios'].value}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'')`;

    } else if (this.reportType == this.RECAUDO) {
      let fechaFormatStr = 'null';
      if (this.form.controls['FechaAcuerdoProximoPago'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaAcuerdoProximoPago'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr1 = 'null';
      if (this.form.controls['FechaEnvioSMS'].value != null) {
        let fechaFormat1: Date = new Date(this.form.controls['FechaEnvioSMS'].value);
        fechaFormatStr1 = fechaFormat1.getFullYear() + '-' + (fechaFormat1.getMonth() < 9 ? '0' + (fechaFormat1.getMonth() + 1) : (fechaFormat1.getMonth() + 1)) + '-' + (fechaFormat1.getDate() < 10 ? '0' + fechaFormat1.getDate() : fechaFormat1.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaNotificacionAlerta'].value != null) {
        let fechaFormat2: Date = new Date(this.form.controls['FechaNotificacionAlerta'].value);
        fechaFormatStr2 = fechaFormat2.getFullYear() + '-' + (fechaFormat2.getMonth() < 9 ? '0' + (fechaFormat2.getMonth() + 1) : (fechaFormat2.getMonth() + 1)) + '-' + (fechaFormat2.getDate() < 10 ? '0' + fechaFormat2.getDate() : fechaFormat2.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaCarta1'].value != null) {
        let fechaFormat3: Date = new Date(this.form.controls['FechaCarta1'].value);
        fechaFormatStr3 = fechaFormat3.getFullYear() + '-' + (fechaFormat3.getMonth() < 9 ? '0' + (fechaFormat3.getMonth() + 1) : (fechaFormat3.getMonth() + 1)) + '-' + (fechaFormat3.getDate() < 10 ? '0' + fechaFormat3.getDate() : fechaFormat3.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['FechaCarta2'].value != null) {
        let fechaFormat4: Date = new Date(this.form.controls['FechaCarta2'].value);
        fechaFormatStr4 = fechaFormat4.getFullYear() + '-' + (fechaFormat4.getMonth() < 9 ? '0' + (fechaFormat4.getMonth() + 1) : (fechaFormat4.getMonth() + 1)) + '-' + (fechaFormat4.getDate() < 10 ? '0' + fechaFormat4.getDate() : fechaFormat4.getDate());
      }

      let fechaFormatStr5 = 'null';
      if (this.form.controls['FechaCarta3'].value != null) {
        let fechaFormat5: Date = new Date(this.form.controls['FechaCarta3'].value);
        fechaFormatStr5 = fechaFormat5.getFullYear() + '-' + (fechaFormat5.getMonth() < 9 ? '0' + (fechaFormat5.getMonth() + 1) : (fechaFormat5.getMonth() + 1)) + '-' + (fechaFormat5.getDate() < 10 ? '0' + fechaFormat5.getDate() : fechaFormat5.getDate());
      }

      let fechaFormatStr6 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr6 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr7 = 'null';
      if (this.form.controls['LlamadaNo_1'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['LlamadaNo_1'].value);
        fechaFormatStr7 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr8 = 'null';
      if (this.form.controls['LlamadaNo_2'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['LlamadaNo_2'].value);
        fechaFormatStr8 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr9 = 'null';
      if (this.form.controls['LlamadaNo_3'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['LlamadaNo_3'].value);
        fechaFormatStr9 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista],[FechaAcuerdoProximoPago],[MontoPactado],[LlamadaNo1],[LlamadaNo2],[LlamadaNo3],[LlamadaNo4],[LlamadaNo5],[FechaEnvioSMS],[FechaNotificacionAlerta],[FechaCarta1],[FechaCarta2],[FechaCarta3],[Fenalco1erBarrido],[Fenalco2doBarrido],[TipificacionMesAnterior],[FechaMetaCelula],[AnalistaRecaudo],[Operacion],[LlamadaNo_1],[LlamadaNo_2],[LlamadaNo_3] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['MontoPactado'].value}'',
        ''${this.form.controls['LlamadaNo1'].value}'',
        ''${this.form.controls['LlamadaNo2'].value}'',
        ''${this.form.controls['LlamadaNo3'].value}'',
        ''${this.form.controls['LlamadaNo4'].value}'',
        ''${this.form.controls['LlamadaNo5'].value}'',
        ''${fechaFormatStr1}'',
        ''${fechaFormatStr2}'',
        ''${fechaFormatStr3}'',
        ''${fechaFormatStr4}'',
        ''${fechaFormatStr5}'',
        ''${this.form.controls['Fenalco1erBarrido'].value}'',
        ''${this.form.controls['Fenalco2doBarrido'].value}'',
        ''${this.form.controls['TipificacionMesAnterior'].value}'',
        ''${fechaFormatStr6}'',
        ''${this.form.controls['AnalistaRecaudo'].value}'',
        ''${this.form.controls['Operacion'].value}'',
        ''${fechaFormatStr7}'',
        ''${fechaFormatStr8}'',
        ''${fechaFormatStr9}''
        )`;

    } else if (this.reportType == this.TRAZABILIDAD) {
      let fechaFormatStr = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista],[TipificacionCorreccionesCtl],[AnalistaTrazabilidad],[FechaMetaCelula] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${this.form.controls['TipificacionCorreccionesCtl'].value}'',
        ''${this.form.controls['AnalistaTrazabilidad'].value}'',
        ''${fechaFormatStr}'')`;
    } else if (this.reportType == this.ORDENES) {

      let fechaFormatStr = 'null';
      if (this.form.controls['FechaEstimadaDePyS'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaEstimadaDePyS'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[Frpl],[QuienFirmaEsfp],[EstadoEsfpFrpl],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista],[EstadoAbogado],
        [ObservacionAbogado],[CualFueElCambio],[NoPredialNacional],[NumeroId],[IdMunicipio],[RadicaciónOrdenPagoPySPredial],[FechaEstimadaDePyS],
        [TipoPyS],[MunicipioPyS],[EstadoPyS],[EstadoOrdenes],[PresentoCambio],[AuxOrdenesEscrituracion],[ObservacionAnalistaACargo],[AnalistaACargoNotaria],[FechaMetaCelula] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['Frpl'].value}'',
        ''${this.form.controls['QuienFirmaEsfp'].value}'',
        ''${this.form.controls['EstadoEsfpFrpl'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${this.form.controls['EstadoAbogado'].value}'',
        ''${this.form.controls['ObservacionAbogado'].value}'',
        ''${this.form.controls['CualFueElCambio'].value}'',
        ''${this.form.controls['NoPredialNacional'].value}'',
        ''${this.form.controls['NumeroId'].value}'',
        ''${this.form.controls['IdMunicipio'].value}'',
        ''${this.form.controls['RadicaciónOrdenPagoPySPredial'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['TipoPyS'].value}'',
        ''${this.form.controls['MunicipioPyS'].value}'',
        ''${this.form.controls['EstadoPyS'].value}'',
        ''${this.form.controls['EstadoOrdenes'].value}'',
        ''${this.form.controls['PresentoCambio'].value}'',
        ''${this.form.controls['AuxOrdenesEscrituracion'].value}'',
        ''${this.form.controls['ObservacionAnalistaACargo'].value}'',
        ''${this.form.controls['AnalistaACargoNotaria'].value}'',
        ''${fechaFormatStr2}'')`;

    } else if (this.reportType == this.RENOVACION) {

      let fechaFormatStr = 'null';
      if (this.form.controls['FechaSeguimientoCoordinador'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaSeguimientoCoordinador'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaSeguimientoAnalista'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaSeguimientoAnalista'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaAsignacion'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaAsignacion'].value);
        fechaFormatStr3 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['FechaSeguimientoBanco'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaSeguimientoBanco'].value);
        fechaFormatStr4 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr5 = 'null';
      if (this.form.controls['FechaUltimaNotificacion'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaUltimaNotificacion'].value);
        fechaFormatStr5 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr6 = 'null';
      if (this.form.controls['FechaCompromiso'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaCompromiso'].value);
        fechaFormatStr6 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr7 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr7 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }


      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[FechaSeguimientoCoordinador],[EstadoCoordinador],[ObservacionCoordinador],[CausalRenovacion],[FechaSeguimientoAnalista],[EstadoAnalista],[ObservacionAnalista],[EstadoPoderAnalista],[TipoDeNovedad],[CampanasEspeciales],[Analista_Outsourcing],[FechaAsignacion],[FechaSeguimientoBanco],[EstadoBanco],[ObservacionBanco],[FechaUltimaNotificacion],[NotificacionesNegocio],[FechaCompromiso],[FechaMetaCelula])
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${this.form.controls['CausalRenovacion'].value}'',
        ''${fechaFormatStr2}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${this.form.controls['EstadoPoderAnalista'].value}'',
        ''${this.form.controls['TipoDeNovedad'].value}'',
        ''${this.form.controls['CampanasEspeciales'].value}'',
        ''${this.form.controls['Analista_Outsourcing'].value}'',
        ''${fechaFormatStr3}'',
        ''${fechaFormatStr4}'',
        ''${this.form.controls['EstadoBanco'].value}'',
        ''${this.form.controls['ObservacionBanco'].value}'',
        ''${fechaFormatStr5}'',
        ''${this.form.controls['NotificacionesNegocio'].value}'',
        ''${fechaFormatStr6}'',
        ''${fechaFormatStr7}'')`;


    } else if (this.reportType == this.ESCRITURACION) {

      let fechaFormatStr = 'null';
      if (this.form.controls['ObservacionCoordinador'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['ObservacionCoordinador'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr1 = 'null';
      if (this.form.controls['FechaPredial'].value != null) {
        let fechaFormat1: Date = new Date(this.form.controls['FechaPredial'].value);
        fechaFormatStr1 = fechaFormat1.getFullYear() + '-' + (fechaFormat1.getMonth() < 9 ? '0' + (fechaFormat1.getMonth() + 1) : (fechaFormat1.getMonth() + 1)) + '-' + (fechaFormat1.getDate() < 10 ? '0' + fechaFormat1.getDate() : fechaFormat1.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaEstampilla'].value != null) {
        let fechaFormat2: Date = new Date(this.form.controls['FechaEstampilla'].value);
        fechaFormatStr2 = fechaFormat2.getFullYear() + '-' + (fechaFormat2.getMonth() < 9 ? '0' + (fechaFormat2.getMonth() + 1) : (fechaFormat2.getMonth() + 1)) + '-' + (fechaFormat2.getDate() < 10 ? '0' + fechaFormat2.getDate() : fechaFormat2.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaPoderFidubogota'].value != null) {
        let fechaFormat3: Date = new Date(this.form.controls['FechaPoderFidubogota'].value);
        fechaFormatStr3 = fechaFormat3.getFullYear() + '-' + (fechaFormat3.getMonth() < 9 ? '0' + (fechaFormat3.getMonth() + 1) : (fechaFormat3.getMonth() + 1)) + '-' + (fechaFormat3.getDate() < 10 ? '0' + fechaFormat3.getDate() : fechaFormat3.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['FechaAsigna'].value != null) {
        let fechaFormat4: Date = new Date(this.form.controls['FechaAsigna'].value);
        fechaFormatStr4 = fechaFormat4.getFullYear() + '-' + (fechaFormat4.getMonth() < 9 ? '0' + (fechaFormat4.getMonth() + 1) : (fechaFormat4.getMonth() + 1)) + '-' + (fechaFormat4.getDate() < 10 ? '0' + fechaFormat4.getDate() : fechaFormat4.getDate());
      }

      let fechaFormatStr5 = 'null';
      if (this.form.controls['FechaMetaComite'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaComite'].value);
        fechaFormatStr5 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr6 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr6 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista],[CaidaEntregas],[TubosDeGestion],[EstadoPromesas],[FechaPredial],[FechaEstampilla],[FechaPoderFidubogota],[RecorridoJuridico], [ClienteExterior],[FechaAsigna],[FechaMetaComite],[FechaMetaCelula],[AnalistaEscrituracion])
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${this.form.controls['CaidaEntregas'].value}'',
        ''${this.form.controls['TubosDeGestion'].value}'',
        ''${this.form.controls['EstadoPromesas'].value}'',
        ''${fechaFormatStr1}'',
        ''${fechaFormatStr2}'',
        ''${fechaFormatStr3}'',
        ''${this.form.controls['RecorridoJuridico'].value}'',
        ''${this.form.controls['ClienteExterior'].value}'',
        ''${fechaFormatStr4}'',
        ''${fechaFormatStr5}'',
        ''${fechaFormatStr6}'',
        ''${this.form.controls['AnalistaEscrituracion'].value}'')`;


      } else if (this.reportType == this.RIESGO) {
      let fechaFormatStr = 'null';
      if (this.form.controls['FechaSubsanado'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaSubsanado'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaSeguimientoAnalista2'].value != null) {
        let fechaFormat2: Date = new Date(this.form.controls['FechaSeguimientoAnalista2'].value);
        fechaFormatStr2 = fechaFormat2.getFullYear() + '-' + (fechaFormat2.getMonth() < 9 ? '0' + (fechaFormat2.getMonth() + 1) : (fechaFormat2.getMonth() + 1)) + '-' + (fechaFormat2.getDate() < 10 ? '0' + fechaFormat2.getDate() : fechaFormat2.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaInicialSeguimientoAnalista'].value != null) {
        let fechaFormat3: Date = new Date(this.form.controls['FechaInicialSeguimientoAnalista'].value);
        fechaFormatStr3 = fechaFormat3.getFullYear() + '-' + (fechaFormat3.getMonth() < 9 ? '0' + (fechaFormat3.getMonth() + 1) : (fechaFormat3.getMonth() + 1)) + '-' + (fechaFormat3.getDate() < 10 ? '0' + fechaFormat3.getDate() : fechaFormat3.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['FechaCompromisoAnalista'].value != null) {
        let fechaFormat4: Date = new Date(this.form.controls['FechaCompromisoAnalista'].value);
        fechaFormatStr4 = fechaFormat4.getFullYear() + '-' + (fechaFormat4.getMonth() < 9 ? '0' + (fechaFormat4.getMonth() + 1) : (fechaFormat4.getMonth() + 1)) + '-' + (fechaFormat4.getDate() < 10 ? '0' + fechaFormat4.getDate() : fechaFormat4.getDate());
      }

      let fechaFormatStr5 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr5 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[FechaSubsanado],[EstadoCoordinador],[FechaSeguimientoAnalista2],[FechaInicialSeguimientoAnalista]
        ,[PrioridadDelNegocio],[MesDeGestion],[ResponsableQueReporta],[Fuente],[AnalistaNegociosEnRiesgo],[FechaCompromisoAnalista]
        ,[DocumentoFirmado],[EstadoDelEncargo],[TipoDeClausulaSiAplicaParaEncargo],[CausalFamilia],[SubsanadoAl100],[Soportes]
        ,[ObservacionesDeNegociosEnRiesgo],[EstadoAnalista],[BancoDeCreditoNegado],[NuevaSolicitudEnOtroBanco],[NombreDelBanco]
        ,[ValorDeSancion],[EstadoParaDesistir],[AsesorDelBanco],[CausalManejoDeAuxiliar],[TiempoRespuesta],[CreditoAprobado]
        ,[CausalDeRiesgo],[CausalDeRiesgos2],[CausalDeRiesgos3],[CausalDeRiesgos4],[NegocioMetaAnioActual],[EstrategiaDesistimiento],[NotificacionesCarta],[FechaMetaCelula])
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${fechaFormatStr2}'',
        ''${fechaFormatStr3}'',
        ''${this.form.controls['PrioridadDelNegocio'].value}'',
        ''${this.form.controls['MesDeGestion'].value}'',
        ''${this.form.controls['ResponsableQueReporta'].value}'',
        ''${this.form.controls['Fuente'].value}'',
        ''${this.form.controls['AnalistaNegociosEnRiesgo'].value}'',
        ''${fechaFormatStr4}'',
        ''${this.form.controls['DocumentoFirmado'].value}'',
        ''${this.form.controls['EstadoDelEncargo'].value}'',
        ''${this.form.controls['TipoDeClausulaSiAplicaParaEncargo'].value}'',
        ''${this.form.controls['CausalFamilia'].value}'',
        ''${this.form.controls['SubsanadoAl100'].value}'',
        ''${this.form.controls['Soportes'].value}'',
        ''${this.form.controls['ObservacionesDeNegociosEnRiesgo'].value}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['BancoDeCreditoNegado'].value}'',
        ''${this.form.controls['NuevaSolicitudEnOtroBanco'].value}'',
        ''${this.form.controls['NombreDelBanco'].value}'',
        ''${this.form.controls['ValorDeSancion'].value}'',
        ''${this.form.controls['EstadoParaDesistir'].value}'',
        ''${this.form.controls['AsesorDelBanco'].value}'',
        ''${this.form.controls['CausalManejoDeAuxiliar'].value}'',
        ''${this.form.controls['TiempoRespuesta'].value}'',
        ''${this.form.controls['CreditoAprobado'].value}'',
        ''${this.form.controls['CausalDeRiesgo'].value}'',
        ''${this.form.controls['CausalDeRiesgos2'].value}'',
        ''${this.form.controls['CausalDeRiesgos3'].value}'',
        ''${this.form.controls['CausalDeRiesgos4'].value}'',
        ''${this.form.controls['NegocioMetaAnioActual'].value}'',
        ''${this.form.controls['EstrategiaDesistimiento'].value}'',
        ''${this.form.controls['NotificacionesCarta'].value}'',
        ''${fechaFormatStr5}'')`;
    }

    else if (this.reportType == this.RENEGOCIACION) {

      let fechaFormatStr = 'null';
      if (this.form.controls['FechaGestion'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaGestion'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaAsignacion'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaAsignacion'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaProxGestion'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaProxGestion'].value);
        fechaFormatStr3 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['AvanceObra'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['AvanceObra'].value);
        fechaFormatStr4 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr5 = 'null';
      if (this.form.controls['FechaInicioEstado'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaInicioEstado'].value);
        fechaFormatStr5 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }
      let fechaFormatStr6 = 'null';
      if (this.form.controls['FechaAgenda'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaAgenda'].value);
        fechaFormatStr6 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }
      let fechaFormatStr7 = 'null';
      if (this.form.controls['FechaEnrolamiento'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaEnrolamiento'].value);
        fechaFormatStr7 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }
      let fechaFormatStr8 = 'null';
      if (this.form.controls['PostuladoMCY'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['PostuladoMCY'].value);
        fechaFormatStr8 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr9 = 'null';
      if (this.form.controls['FechaMetaCelula'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaMetaCelula'].value);
        fechaFormatStr9 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }



      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],
        [EstadoCoordinador],
        [ObservacionCoordinador],
        [FechaGestion],
        [EstadoAnalista],
        [ObservacionAnalista],
        [TuboGestion],
        [AnalistaAsignado],
        [FechaAsignacion],
        [Compromiso],
        [FechaProxGestion],
        [NegocioConCierreFinanciero],
        [RecursosPropios],
        [IngresoFamiliar],
        [ClasificacionSisben],
        [SimmularConMCY],
        [AccionRecomendada],
        [EstadoSubsidioMCY],
        [ValorCreditoAcordado],
        [ObservacionCampanaEnrolamientoSisben],
        [AvanceObra],
        [BonoEstrategiaCredito],
        [ClienteNoAcepta],
        [FechaInicioEstado],
        [FechaAgenda],
        [Agenda],
        [SemaforoSatisfaccion],
        [NumeroRadicadoEnrolamiento],
        [FechaEnrolamiento],
        [PostuladoMCY],
        [FechaMetaCelula]
        )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${this.form.controls['ObservacionCoordinador'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'',
        ''${this.form.controls['TuboGestion'].value}'',
        ''${this.form.controls['AnalistaAsignado'].value}'',
        ''${fechaFormatStr2}'',
        ''${this.form.controls['Compromiso'].value}'',
        ''${fechaFormatStr3}'',
        ''${this.form.controls['NegocioConCierreFinanciero'].value}'',
        ''${this.form.controls['RecursosPropios'].value}'',
        ''${this.form.controls['IngresoFamiliar'].value}'',
        ''${this.form.controls['ClasificacionSisben'].value}'',
        ''${this.form.controls['SimmularConMCY'].value}'',
        ''${this.form.controls['AccionRecomendada'].value}'',
        ''${this.form.controls['EstadoSubsidioMCY'].value}'',
        ''${this.form.controls['ValorCreditoAcordado'].value}'',
        ''${this.form.controls['ObservacionCampanaEnrolamientoSisben'].value}'',
        ''${fechaFormatStr4}'',
        ''${this.form.controls['BonoEstrategiaCredito'].value}'',
        ''${this.form.controls['ClienteNoAcepta'].value}'',
        ''${fechaFormatStr5}'',
        ''${fechaFormatStr6}'',
        ''${this.form.controls['Agenda'].value}'',
        ''${this.form.controls['SemaforoSatisfaccion'].value}'',
        ''${this.form.controls['NumeroRadicadoEnrolamiento'].value}'',
        ''${fechaFormatStr7}'',
        ''${fechaFormatStr8}'',
        ''${fechaFormatStr9}'')`;

    }

    else if (this.reportType == this.DESISTIMIENTOS) {

      let fechaFormatStr = 'null';
      if (this.form.controls['FechaEnvioCertificacionBancaria'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaEnvioCertificacionBancaria'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaElaboracionMemorando'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaElaboracionMemorando'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],
        [Indemnizacion],
        [FormaDevolucion],
        [Banco],
        [NumeroCuenta],
        [TipoCuenta],
        [EntidadEncargadaDevolucion],
        [EstadoDesistimiento],
        [TipoDesistimiento],
        [FechaEnvioCertificacionBancaria],
        [FechaElaboracionMemorando],
        [NumeroMemorando],
        [EstadoFinal],
        [Observaciones],
        [NotaMemoFidudavivienda],
        [Asistente],
        [VoboAnalista]
        )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['Indemnizacion'].value}'',
        ''${this.form.controls['FormaDevolucion'].value}'',
        ''${this.form.controls['Banco'].value}'',
        ''${this.form.controls['NumeroCuenta'].value}'',
        ''${this.form.controls['TipoCuenta'].value}'',
        ''${this.form.controls['EntidadEncargadaDevolucion'].value}'',
        ''${this.form.controls['EstadoDesistimiento'].value}'',
        ''${this.form.controls['TipoDesistimiento'].value}'',
        ''${fechaFormatStr}'',
        ''${fechaFormatStr2}'',
        ''${this.form.controls['NumeroMemorando'].value}'',
        ''${this.form.controls['EstadoFinal'].value}'',
        ''${this.form.controls['Observaciones'].value}'',
        ''${this.form.controls['NotaMemoFidudavivienda'].value}'',
        ''${this.form.controls['Asistente'].value}'',
        ''${this.form.controls['VoboAnalista'].value}'')`;


    }

    else if (this.reportType == this.PAZYSALVOS) {
      let fechaFormatStr = 'null';
      if (this.form.controls['FechaSolicitud'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaSolicitud'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr2 = 'null';
      if (this.form.controls['FechaRevision'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaRevision'].value);
        fechaFormatStr2 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr3 = 'null';
      if (this.form.controls['FechaObservacionAjustes'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaObservacionAjustes'].value);
        fechaFormatStr3 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr4 = 'null';
      if (this.form.controls['FechaEvacuadoPyS'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaEvacuadoPyS'].value);
        fechaFormatStr4 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr5 = 'null';
      if (this.form.controls['FechaNotificacionObsTramites'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaNotificacionObsTramites'].value);
        fechaFormatStr5 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      let fechaFormatStr6 = 'null';
      if (this.form.controls['FechaDevolucionTramites'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['FechaDevolucionTramites'].value);
        fechaFormatStr6 = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],
        [NegocioFenalpagare],
        [CasosAutorizacionEspecial],
        [AjusteAplicacionPago],
        [TipoSolicitud],
        [ProcesoPendienteCartera],
        [ResponsableCartera],
        [ObservacionCartera],
        [AplicacionBonoDescuento],
        [EstadoPyS],
        [CausalDevolucion],
        [ObservacionesAnalistaTramites],
        [DocumentoGenerado],
        [ResponsableCarteraDos],
        [ValorBonoDescuento],
        [LiquidadorGastosEscrituracion],
        [MotivoDevolucion],
        [FechaSolicitud],
        [FechaRevision],
        [FechaObservacionAjustes],
        [FechaEvacuadoPyS],
        [FechaNotificacionObsTramites],
        [FechaDevolucionTramites]
        )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['NegocioFenalpagare'].value}'',
        ''${this.form.controls['CasosAutorizacionEspecial'].value}'',
        ''${this.form.controls['AjusteAplicacionPago'].value}'',
        ''${this.form.controls['TipoSolicitud'].value}'',
        ''${this.form.controls['ProcesoPendienteCartera'].value}'',
        ''${this.form.controls['ResponsableCartera'].value}'',
        ''${this.form.controls['ObservacionCartera'].value}'',
        ''${this.form.controls['AplicacionBonoDescuento'].value}'',
        ''${this.form.controls['EstadoPyS'].value}'',
        ''${this.form.controls['CausalDevolucion'].value}'',
        ''${this.form.controls['ObservacionesAnalistaTramites'].value}'',
        ''${this.form.controls['DocumentoGenerado'].value}'',
        ''${this.form.controls['ResponsableCarteraDos'].value}'',
        ''${this.form.controls['ValorBonoDescuento'].value}'',
        ''${this.form.controls['LiquidadorGastosEscrituracion'].value}'',
        ''${this.form.controls['MotivoDevolucion'].value}'',
        ''${fechaFormatStr}'',
        ''${fechaFormatStr2}'',
        ''${fechaFormatStr3}'',
        ''${fechaFormatStr4}'',
        ''${fechaFormatStr5}'',
        ''${fechaFormatStr6}'')`;

    }

    else if (this.reportType == this.MACRO360) {
      let fechaFormatStr = 'null';
      if (this.form.controls['ObservacionCoordinador'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['ObservacionCoordinador'].value);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }

      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[EstadoCoordinador],[ObservacionCoordinador],[EstadoAnalista],[ObservacionAnalista] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${this.form.controls['EstadoCoordinador'].value}'',
        ''${fechaFormatStr}'',
        ''${this.form.controls['EstadoAnalista'].value}'',
        ''${this.form.controls['ObservacionAnalista'].value}'')`;
    }

    else if (this.reportType == this.INTERNACIONAL) {
      let fechaFormatStr1 = 'null';
      if (this.form.controls['AsesorSeguimiento1'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['AsesorSeguimiento1'].value);
        fechaFormatStr1  = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 10 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }
      let fechaFormatStr2 = 'null';
      if (this.form.controls['AsesorSeguimiento2'].value != null) {
        let fechaFormat: Date = new Date(this.form.controls['AsesorSeguimiento2'].value);
        fechaFormatStr2  = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 10 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }


      insertDate = `INSERT INTO #tblTEMP
      ([ID_PA],[AsesorSeguimiento1],[AsesorSeguimiento2],[NotificacionCarta],[ObservacionAsesor],[EstadoRecaudo],[EstadoCredito],[EstadoPromesa],[EstadoLegalizacion],[EstadoEscrituracion],[EstadoEntrega],[EstadoPoderes],[MotivoRiesgo] )
        VALUES (''${this.form.controls['ID_PA'].value}'',
        ''${fechaFormatStr1}'',
        ''${fechaFormatStr2}'',
        ''${this.form.controls['NotificacionCarta'].value}'',
        ''${this.form.controls['ObservacionAsesor'].value}'',
        ''${this.form.controls['EstadoRecaudo'].value}'',
        ''${this.form.controls['EstadoCredito'].value}'',
        ''${this.form.controls['EstadoPromesa'].value}'',
        ''${this.form.controls['EstadoLegalizacion'].value}'',
        ''${this.form.controls['EstadoEscrituracion'].value}'',
        ''${this.form.controls['EstadoEntrega'].value}'',
        ''${this.form.controls['EstadoPoderes'].value}'',
        ''${this.form.controls['MotivoRiesgo'].value}'')`;
    }


    insertDate = String(insertDate).toString();

    insertDate = insertDate.replace("Invalid Date", "null");
    insertDate = insertDate.replace("Vacio", "null");
    insertDate = insertDate.replace("NULL", "null");
    insertDate = insertDate.replace("''null''", "NULL");

    console.log('insertDate', insertDate);

    let auditList: any = [];
    console.log('this.form.controls', this.form.controls);
    console.log('this.beforeForm.controls', this.beforeList);

    Object.keys(this.form.controls).forEach(key => {

      let before = this.beforeList[key];
      let after = this.form.controls[key].value;
      if (before != after) {
        auditList.push({ name: key, before: before, after: after, ID_PA: this.form.controls['ID_PA'].value });
      }
    });

    console.log('auditList', auditList);


    this.legalizacionService.updateData(insertDate, this.reportType, auditList)
      .subscribe(
        (data: any) => {
          console.log(data);
        }, err => {
          console.log(err);
        }
      );


    this.dialogRef.close();

  }

  multipleUpdateLegalizacion(field: any, type?: any) {
    let newValue = this.form.controls[field].value;
    console.log('field', field);
    console.log('type', type);

    if (type == 1) {
      let fechaFormatStr = 'null';
      if (newValue != null) {
        let fechaFormat: Date = new Date(newValue);
        fechaFormatStr = fechaFormat.getFullYear() + '-' + (fechaFormat.getMonth() < 9 ? '0' + (fechaFormat.getMonth() + 1) : (fechaFormat.getMonth() + 1)) + '-' + (fechaFormat.getDate() < 10 ? '0' + fechaFormat.getDate() : fechaFormat.getDate());
      }
      newValue = fechaFormatStr;
    } else if (type == 2) {
      let horaFormatStr = 'null';
      let horaFormat: Date = new Date(newValue);
      horaFormatStr = (horaFormat.getHours() < 9 ? '0' + (horaFormat.getHours() + 1) : (horaFormat.getHours())) + ':' + (horaFormat.getMinutes() < 9 ? '0' + (horaFormat.getMinutes() + 1) : (horaFormat.getMinutes())) + ':' + (horaFormat.getSeconds() < 10 ? '0' + horaFormat.getSeconds() : horaFormat.getSeconds());

      newValue = horaFormatStr;
    }

    console.log('newValue', newValue);


    this.displayLoading = true;
    this.legalizacionService.multipleUpdateLegalizacion(field, newValue, this.obras, this.sortStr, this.filterStr, this.reportType)
      .subscribe(
        (data: any) => {

          if (data.code == 0) {
            this.displayLoading = false;
            this.confirmationService.confirm({
              header: 'Mensaje',
              message: 'Se ha realizado la modificacion masiva con exito',
              dismissableMask: true,
              rejectVisible: false,
              acceptLabel: 'OK',
              accept: () => {
                this.confirmationService.close();
                this.dialogRef.close();
              }
            })
          } else {
            console.error('Error al persistir datos masivos: ', data.message);
            this.displayLoading = false;
            this.confirmationService.confirm({
              header: 'Mensaje',
              message: 'Se ha presentado un error al intentar realizar la modificacion masiva',
              dismissableMask: true,
              rejectVisible: false,
              acceptLabel: 'OK',
              accept: () => {
                this.confirmationService.close();
                this.dialogRef.close();
              }
            })
          }
        }, err => {
          this.displayLoading = false;
          this.confirmationService.confirm({
            header: 'Mensaje',
            message: 'Se ha presentado un error al intentar realizar la modificacion masiva',
            dismissableMask: true,
            rejectVisible: false,
            acceptLabel: 'OK',
            accept: () => {
              this.confirmationService.close();
              this.dialogRef.close();
            }
          })
        }
      )
  }

  confirm(id: any, type?: any) {
    let role = localStorage.getItem('role');

    let numFilas = (role == 'Administrador' || role == 'Coordinador') ? 2000 : 100;

    if (this.numRegistros > numFilas) {
      this.confirmationService.confirm({
        header: 'Mensaje',
        message: `El limite de resgitros a modificar es ${numFilas}.`,
        dismissableMask: true,
        rejectVisible: false,
        acceptLabel: 'OK',
        accept: () => {
          this.confirmationService.close();
        }
      });
      return;
    }

    console.log('##confirm##');

    this.confirmationService.confirm({
      message: 'Estas seguro que deseas aplicar este cambio a todos los registros filtrados actualmente?',
      accept: () => {
        this.multipleUpdateLegalizacion(id, type);
      },
      reject: () => {
        this.dialogRef.close();
        this.confirmationService.close();
      }
    });
  }

  loadingAction(evt) {
    console.log('evt', evt);
    this.displayLoading = true;
  }


  clear(id: any) {
    if (id == 'EstadoCoordinador') {
      this.searchTextEstadoCoordinador = "";
    } else if (id == 'EstadoAnalista') {
      this.searchTextEstadoAnalista = "";
    } else if (id == 'AsignacionAnalista') {
      this.searchTextAsignacionAnalista = "";
    } else if (id == 'HoradeEntrega') {
      this.searchTextHoradeEntrega = "";
    }
  }

  protected getToolName(name: number): string {

    if (name == this.LEGALIZACION) {
      return 'Legalizacion';
    } else if (name == this.PROMESA) {
      return 'Promesas';
    } if (name == this.SUBSIDIO) {
      return 'Subsidio';
    } if (name == this.SEGUIMIENTO_SUBSIDIO) {
      return 'SegSubsidio';
    } if (name == this.ENTREGA) {
      return 'Entregas';
    } else if (name == this.DESEMBOLSO) {
      return 'Desembolso';
    } if (name == this.RECAUDO) {
      return 'Recaudo';
    } else if (name == this.TRAZABILIDAD) {
      return 'Trazabilidad';
    } else if (name == this.ORDENES) {
      return 'Ordenes';
    } else if (name == this.RENOVACION) {
      return 'Renovacion';
    } else if (name == this.ESCRITURACION) {
      return 'Escrituracion';
    } else if (name == this.RIESGO) {
      return 'Riesgo';
    } else if (name == this.RENEGOCIACION) {
      return 'Renegociacion';
    } else if (name == this.DESISTIMIENTOS) {
      return 'Desistimientos';
    } else if (name == this.PAZYSALVOS) {
      return 'PazySalvos';
    } else if (name == this.MACRO360) {
      return 'Macro360';
    } else if (name == this.INTERNACIONAL) {
      return 'Internacional';
    }



    return;
  }

}
